module.exports={
	"LEFT": "Left",
	"CENTER": "Center",
	"RIGHT": "Right",
	"LOGIN": {
		"SUBMIT": "Sign in",
		"PASSWORD": "Password",
		"FORGOT_PASSWORD": "Forgot my password",
		"SHOW_PASSWORD": "Show Password",
		"HIDE_PASSWORD": "Hide Password",
		"PROGRESS": {
			"LOADING_PROFILE": "Loading user profile...",
			"VERIFYING_PERMISSIONS": "Verifying permissions...",
			"LOADING_CONFIG": "Loading configuration...",
			"LOADING_DEPARTMENTS": "Loading departments...",
			"REDIRECTING": "Redirecting..."
		}
	},
	"WAITING": {
		"LOGOUT": "Log out",
		"BOOT_LOADING": "Loading application..."
	},
	"LOADING_DIRECTIVE": {
		"LOADING": "Loading data..."
	},
	"CALENDAR": {
		"CURRENT-TEXT": "Today",
		"LUNES": "Monday",
		"MARTES": "Tuesday",
		"MIERCOLES": "Wednesday",
		"JUEVES": "Thursday",
		"VIERNES": "Friday",
		"SABADO": "Saturday",
		"DOMINGO": "Sunday",
		"DAILY": "Daily",
		"WEEKLY": "Weekly"
	},
	"AGGRID": {
		"PAGE": "Page",
		"MORE": "More",
		"TO": "to",
		"OF": "of",
		"NEXT": "Next",
		"LAST": "Last",
		"FIRST": "First",
		"PREVIOUS": "Previous",
		"LOADING": "Loading...",
		"SELECTALL": "Select All",
		"SEARCH": "Search...",
		"BLANKS": "Blanks",
		"EQUAL": "Equal",
		"LESSTHAN": "Less than",
		"BETWEEN": "Between",
		"GREATERTHAN": "Greater than",
		"APPLYFILTER": "Apply filter",
		"REMOVEFILTER": "Remove filter",
		"FILTER": "Filter",
		"CONTAINS": "Contains",
		"STARTWITH": "Start with",
		"ENDWITH": "End with",
		"GROUP": "Group",
		"COLUMNS": "Column",
		"GROUPCOLUMNS": "Group column",
		"GROUPCOLS_EMPTY": "Move columns",
		"VALUECOLUMNS": "Value column",
		"VALUECOLS_EMPTY": "Move columns"
	},
	"DASHBOARD": {
		"VALIDATIONS": "Validations",
		"SITES": "Sites",
		"DEPARTMENTS": "Departments",
		"STATISTICS": "Statistics",
		"WEBHOOKS": "Webhooks",
		"USERS": "Users",
		"ADMIN_CONSOLE": "Admin Console",
		"TASKS": "Tasks",
		"ADMIN": "Admin",
		"GRAPHS": "Graphs",
		"HELP": "HELP - WIZARD",
		"HELP_CENTER": "Help Center",
		"LOG_OUT": "Log out",
		"LOGGING_OUT": "Closing user session...",
		"TEAMS": "Teams",
		"LST_EMAILS": "Emails, comma separated",
		"FIND_USERS": "Find Users",
		"FIND_USERS_TAGS": "Find Users & Tags",
		"FIND_TAGS": "Find Tags",
		"SHOW_ALL": "See All",
		"LOADING": "Loading...",
		"NO_AUTHORIZED": "Not authorized",
		"ACCEPT": "Accept",
		"OK": "OK",
		"CONTINUE": "Continue",
		"SYNC": "Synchronize",
    	"GET_PARAMS": "Get Parameters",
		"REJECT": "Reject",
		"REJECTED": "Rejected",
		"ADD": "Add",
		"CANCEL": "Cancel",
		"CHOOSE": "Choose",
		"ADVANCED": "Advanced",
		"CLOSE": "Close",
		"FINISH": "Finish",
		"CONFIG": "Config",
		"DELETE": "Delete",
		"CLEAR_DATE": "Clear date",
		"EDIT": "Edit",
		"COPY": "Copy",
		"FIND": "Find",
		"FORMS": "Forms",
		"RECORDS": "Records",
		"NEXT": "Next",
		"PREVIOUS": "Previous",
		"REMOVE": "Remove",
		"SAVE": "Save",
		"SAVE_CLOSE": "Save and Close",
		"INTEGRATIONS": "Integrations",
		"SHEET": "Voolks Sheet",
		"KEY": "Key",
		"VALUE": "Value",
		"DASH_BUILDER": {
			"ADD_PAGE": "Add Page",
			"EXPORT": "Export",
			"DESCRIP": "Description",
			"UPDATE_FOOTER": "Hide Auto Update Bar",
			"NAME": "Name",
			"AI_SCHEMA": {
				"BUTTON": "AI Schema",
				"TITLE": "AI Schema",
				"ENABLE": "Enable AI data-entry assistance",
				"TERMS_REQUIRED": "To enable the assistant, the terms and conditions must be accepted.",
				"PAGE": "Page {{n}}",
				"VALIDATOR_PAGE": "Validator · Page {{n}}",
				"EMPTY_PAGE": "No elements",
				"EMPTY_FORM": "This form has no pages.",
				"TERMS_TITLE": "AWS terms and conditions",
				"TERMS_SCROLL": "Scroll to the end of the text to enable Accept. If you cancel, assistance stays disabled.",
				"TERMS_INTRO": "To enable AI data-entry assistance you must accept the Amazon Web Services terms that govern the use of those services. The binding text is the one published by AWS at the links in this window.",
				"TERMS_DOCS": "Current AWS terms",
				"TERMS_AGREEMENT": "AWS Customer Agreement",
				"TERMS_AGREEMENT_URL": "https://aws.amazon.com/agreement/",
				"TERMS_SERVICE": "AWS Service Terms",
				"TERMS_SERVICE_URL": "https://aws.amazon.com/service-terms/",
				"TERMS_AUP": "AWS Acceptable Use Policy",
				"TERMS_AUP_URL": "https://aws.amazon.com/aup/",
				"TERMS_PRIVACY": "AWS Privacy Notice",
				"TERMS_PRIVACY_URL": "https://aws.amazon.com/privacy/",
				"TERMS_P1": "Data-entry assistance uses artificial intelligence services provided through AWS. By accepting, you state that you reviewed and accept the AWS Customer Agreement, the AWS Service Terms, and the AWS Acceptable Use Policy, in the current versions published by Amazon Web Services.",
				"TERMS_P2": "Use of the assistance must follow those conditions. Unlawful, abusive, or other use that violates the acceptable use policy is not allowed. Whoever enables the assistant is responsible for the data that is sent and for having the authorizations required to process it.",
				"TERMS_P3": "AWS may process the data sent to the assistant according to its terms and the service configuration. The description entered on each form element is part of the schema the assistant uses to interpret the data entry.",
				"TERMS_P4": "AWS may update those documents. If this summary and the official text differ, the text published by AWS prevails. The links open the full terms on the Amazon Web Services site.",
				"TERMS_P5": "Assistance stays disabled until this text is scrolled to the end and Accept is pressed. Cancel leaves the assistant off and does not record acceptance.",
				"TERMS_END": "End of the review. By accepting, you confirm that you read the AWS terms listed above and that you accept them for the use of AI data-entry assistance on this form."
			},
			"MUST_SAVE": "New form, save it before accessing advanced settings",
			"CONFIGS": "Configurations",
			"OTHERS_CONFIG": "Others configurations",
			"OTHERS_CONFIG_BUTTON": "Others",
			"EMAIL_CONFIG": "Configure Sending Emails",
			"ACTION_CONFIG": "Configure Actions",
			"ACTION_CONFIG_BUTTON": "Actions",
			"ACTION_CONFIGURED": "Configured Actions :",
			"ACTION_CONFIGURED_NO": "No actions configured",
			"ACTION_CONFIGUR_BUTTON": "CONFIGURE",
			"REPORT_CONFIG": "Configure Report",
			"REPORT_CONFIG_BUTTON": "Report",
			"REPORT_CONFIG_DEPT": "Reports",
			"BEHAVIOR_CONFIG": "Configure Behavior",
			"BEHAVIOR_CONFIG_BUTTON": "Behavior",
			"VALIDATE_TITLE": "Item Validations",
			"VALIDATE_CONFIG": "Configure Validation",
			"VALIDATE_CONFIG_BUTTON": "Validations",
			"VALIDATE_REQUIRED": "Requires Validation",
			"VALIDATE_Q_REQUIRED": "Required Instances",
			"VALIDATE_TYPE": "Validators",
			"VALIDATE_TYPE-DISTINCT": "different",
			"VALIDATE_TYPE-NOT_CONSECUTIVE": "not consecutive",
			"VALIDATE_TYPE-INDISTINCT": "indistinct",
			"VALIDATE_TYPE-INSTANCE_DEFINED": "Instance Defined",
			"VALIDATE_USERS_SELECTION": "Indicate below the users, supervisors, or owners who can perform the validation. To allow any of them, it must remain empty.",
			"VALIDATE_USERS_SELECTION_INSTANCE": "Indicate below the users, supervisors, owners, and/or labels that can perform the validation and certification. To allow any of them, it must remain empty.",
			"#1": "#1",
			"#2": "#2",
			"INPUT_VALIDATION": "Validation",
			"INPUT_CERTIFICACTION": "Certification",
			"SELECT_IN_FIELD": "Selected in Field",
			"VALIDATE_NOTIFY": "Send email to validators",
			"VALIDATE_EXPAND_MASK_USERS": "Expand mask users",
			"VALIDATE_TEAMLEADER": "Validate Team Leader",
			"PAGE": "Page",
			"PAGE_WITHOUT_ELEMENTS": "Page without elements!",
			"ELEMENT_LOADING": "LOADING",
			"SAVE_OK_TOAST": "Form Saved",
			"DIAG_DEL_PAGE": {
				"TITLE": "Delete page",
				"BODY": "Do you want to delete this page?",
				"ACCEPT": "Delete page"
			},
			"DIAG_DEL_ELEMENT": {
				"TITLE": "Delete item",
				"BODY": "Do you want to remove this element?",
				"BODYWITHDATA": "The form already has records. THE DATA OF THE ELEMENT WILL BE LOST, are you sure you want to delete this element?.",
				"ACCEPT": "Delete item"
			},
			"ELEMENTS": {
				"DOCS": "Documents",
				"VIDEOS": "Videos",
				"PHOTOS": "Photos",
				"SIGN": "Signature",
				"AUTONUMERIC": "Autonumeric ",
				"TITLE": "Title",
				"GROUP": "Group",
				"SIMPLELIST": "Simple list",
				"TEXT": "Text",
				"SENDEMAIL": "Send Email",
				"SELECT": "Selection",
				"PIVOTCHART": "Pivot Chart",
				"GRID": "Grid",
				"MAP": "Map",
				"DATASOURCE": "DataSource",
				"VALIDATE": "Validate online",
				"POPULATE": "Populate",
				"CHECKBOX": "Checkbox",
				"MULTIPLE": "Multiple",
				"GEO": "Geolocation",
				"TIMESTAMP": "Timestamp",
				"DATE": "Date",
				"TIME": "Time",
				"NUMBER": "Number",
				"QR": "QR and Bar Code",
				"FORMULA": "Formula",
				"DURATION": "Duration",
				"LINK_REPORT": "Link Report",
				"TEXT_VALIDATOR": "Validator Text",
				"SELECT_VALIDATOR": "Validator Selection"
			},
			"CONFIG_DIR": {
				"TITLE": "Title",
				"AI_DESCRIPTION": "Description",
				"AI_DESCRIPTION_HELP": "This description will be used in the AI Schema",
				"MIN": "Min Value",
				"MAX": "Max Value",
				"AUTO_SET": "Set automatically when creating record",
				"PRECISION15M": "Force a precision of 15m or better",
				"MIN_REQ_PRECISION": "Minimum Required Precision",
				"AUTO_MOBILE": "Mobile Automatic",
				"FORCEDECIMALES": "Force decimals",
				"THOUSANDSEPARATOR": "Thousand separator",
				"BTNCOUNTER": "Buttons to up/down value",
				"ALERT_ONLY": "Alert only",
				"MAXDECIMALSCOUNTINFO": "Limit of decimals",
				"VALUESCOUNTER": "step of buttons",
				"PLACEHOLDER": "Placeholder",
				"LIMIT_PHOTOS": "Number of Files",
				"BODYCAM": "Bodycam",
        "BODYCAM_INFO": "Single long-form video with auto-segmentation",
				"ALLOW_GALLERY": "Allow files from Gallery",
				"VIDEO_MUTE": "Video without sound",
				"ALLOW_OLD_DATES": "Allow older dates",
				"ALLOW_LATER_DATES": "Allow later dates",
				"MAX_OLD_DATES": "Maximum days back",
				"MAX_LATER_DATES": "Maximum days forward",
				"ALLOW_OLD_TIMES": "Allow Old Times",
				"PRELOAD_ITEMS": "Preload Items",
				"MAX_OLD_TIMES": "Maximum Hours backwards",
				"ALLOW_LATER_TIMES": "Allow later times",
				"MAX_LATER_TIMES": "Maximum Hours forward",
				"SHOW_IF_CHECKBOX": "Show if Checkbox is Selected:",
				"SHOW_IF_SELECT": "Show if Option is selected:",
				"TEXTCOLOR": "Text Color",
				"BACKGROUNDCOLOR": "Background Color",
				"WIDTH_APP": "Width (App)",
				"REQUIRED": "Required",
				"SORT": "Sort Alphabetically",
				"USE_AS_TITLE": "Use as Item Title",
				"TITLE_AS_COLS": "Item title as Columns",
				"SHOW_FINDER": "Show Finder",
				"USE_WITH_FILTER": "Use as Search Filter",
				"GPS_STAMP": "GPS Info",
				"NOW_STAMP": "DateTime",
				"NO_MODAL": "No modal window",
				"OPTIONS_AS_BUTTONS": "Options as Buttons",
				"SIGN_FROM_PROFILE": "Allow to bring signature of the profile",
				"CLOSE_RECORD": "Close record",
				"ONLY_ONE": "Only one possible option",
				"ROW_SPAN": "Multilines",
				"CONVERT_CASE": "Convert",
				"ALIGN": "Align",
				"NONE_CASE": "No change",
				"UPPER_CASE": "UpperCase",
				"LOWER_CASE": "LowerCase",
				"HREF": "Link Address(for example https:///www.example.com/doc1.pdf)",
				"HINT": "Hint",
				"HIDDEN": "Hidden in the App",
				"HIDDEN_LABEL": "Hidden Label",
				"SL_MINRECORD": "Min record count",
				"READONLY": "Read Only",
				"LASTVALUE": "Value to which the number of items is added",
				"ASSELECT": "Select from options",
        "Q_DECIMALS": "Number of decimal places",
        "ADD_SHOWCASE_LOGO": "Add logo",
        "ADD_SHOWCASE_LOGO_HINT": "It will be resized to a maximum of 80×80. It can end up smaller.",
        "ADD_SHOWCASE_IMAGE": "Add image",
        "ADD_SHOWCASE_IMAGE_HINT": "It will be resized to a maximum of 800×800. It can end up smaller.",
        "IMAGE_PROCESS_ERROR": "Could not process the image",
        "SHOWCASE_LOGO": "Logo",
        "SHOWCASE_IMAGE": "Image",
        "SHOWCASE_LOGO_PREVIEW": "Logo preview",
        "SHOWCASE_IMAGE_PREVIEW": "Image preview"
			},
			"DURATION_DIR": {
				"DATECOMPARISION_TYPE": {
					"TITLE": "Type of Comparison:",
					"DATE": "Dates",
					"TIME": "Hours",
					"TIMESTAMP": "Timestamps"
				},
				"START_ELEMENT": "Start Element",
				"END_ELEMENT": "End Element",
				"HIDDEN": "Hidden in the App:",
				"SAME_DAY": "End on the same day as the start"
			},
			"FORM_FACTORY": {
				"SAVE_ERR_DEPTO": "Department not Compatible",
				"SAVE_ERR_NAME": "Name Required",
				"SAVE_ERR_NAME_DESC": "Name and Description Required"
			},
			"FORMULA_DIR": {
				"ADVANCED": "Advanced",
				"PLACEHOLDER": "ie: (2+a)*2/b",
				"VAR_COL": "Variable",
				"ELEM_COL": "Element",
				"VAL_COL": "Testing",
				"TOTAL": "Total",
				"RETURN": "Return",
				"Q_DECIMALS": "Number of decimal places",
				"RETURN_DATA_TYPE": "Return data type"
			},
			"INTEGRATION_DIR": {
				"NO_AVAILABLE": "This item cannot be integrated with any service.",
				"INFO_WS": "To integrate the element with a web service, it is necessary to create and configure it. In this section you can configure the dynamic aspects of it.",
				"SELECT_INT": "Select integration to use",
				"VIEW_INTEGRATION": "View integration",
				"PARAMETERS": "Map elements to dynamic parameters of the integration.",
				"GEO_DATA": "Geo Data",
				"GEO_LAT": "latitude",
				"GEO_LNG": "longitude",
				"GEO_LATLNG": "latitude,longitude",
				"RETURN": "Map elements to the data returned by the integration.",
				"PARAM": "Parameter",
				"FIELD": "Field",
				"DEFAULT_VALUE": "Default value",
				"USER_MODE": "Sync on user request",
				"FORM": "Form",
				"VALIDATOR": "Validator",
				"PAGE": "Page"
			},
			"OPTIONS_DIR": {
				"HELP_MAIL": "Enter emails separated by commas. If you want to send the email to the user who generated the item, just write the reserved word: \"user\" ",
				"HELP": "Enter comma separated values. If the value includes a comma, enclose the entire value in quotation marks. Ex: \"Monday,Tuesday and Friday\". f you require scores for the options to use in the formula field, you should separate the value of the description with the character. | . Example: \"3|Option X \", \"5|Option Y \". ",
				"COPY_ICON": "Click to copy values ​​to clipboard",
				"PASTE_ICON": "Click to paste values from clipboard",
				"NEW_OPTION": "Enter Values",
				"REMOVE_ALL": "Remove all options",
				"ERR_CLIPBOARD_UNAVAILABLE_TITLE": "Error: Clipboard unavailable",
				"ERR_CLIPBOARD_UNAVAILABLE_BODY": "The browser does not allow pasting from the clipboard in this environment.",
				"ERR_PASTE_INVALID_TITLE": "Error: Invalid format",
				"ERR_PASTE_INVALID_BODY": "Pasted content must be a comma-separated list of values. Wrap values that contain commas or spaces in quotes. E.g. \"Option A\", \"3|Option B\"",
				"ERR_PASTE_READ_FAILED_TITLE": "Error: Could not paste",
				"ERR_PASTE_READ_FAILED_BODY": "Could not read the clipboard. Check your browser permissions."
			},
			"OPTIONS_REF_COLOR": {
				"ERR_INVALID_REF_TITLE": "Error: Invalid reference",
				"ERR_INVALID_REF_BODY": "The reference cannot be empty.",
				"ERR_INVALID_COLOR_TITLE": "Error: Invalid color",
				"ERR_INVALID_COLOR_BODY": "The color must be in hexadecimal format (#FFFFFF).",
				"ERR_DUPLICATE_REF_TITLE": "Error: Duplicate reference",
				"ERR_DUPLICATE_REF_BODY": "The reference you entered already exists in the list.",
				"ERR_CLIPBOARD_UNAVAILABLE_TITLE": "Error: Clipboard unavailable",
				"ERR_CLIPBOARD_UNAVAILABLE_BODY": "This browser does not allow pasting from the clipboard in this environment.",
				"ERR_PASTE_INVALID_JSON_TITLE": "Error: Invalid format",
				"ERR_PASTE_INVALID_JSON_BODY": "The clipboard content is not valid.",
				"ERR_PASTE_INVALID_SHAPE_TITLE": "Error: Invalid format",
				"ERR_PASTE_INVALID_SHAPE_BODY": "Pasted content must be a JSON object in the form reference: color.",
				"ERR_PASTE_NO_VALID_TITLE": "Error: No valid data",
				"ERR_PASTE_NO_VALID_BODY": "No references with valid colors were found to paste.",
				"ERR_PASTE_READ_FAILED_TITLE": "Error: Could not paste",
				"ERR_PASTE_READ_FAILED_BODY": "Could not read the clipboard. Check your browser permissions.",
				"ERR_MODAL_REFERENCE_REQUIRED": "Error: Enter a valid reference.",
				"ERR_MODAL_COLOR_INVALID": "Error: Enter a valid color in hexadecimal format (#FFFFFF).",
				"ERR_MODAL_DUPLICATE_REFERENCE": "The reference you entered already exists in the list."
			},
			"OPTIONS_ALT_DIR": {
				"HELP_RECIPIENTS": "Emails, WhatsApp numbers, or reserved words can be entered. Enter emails separated by a comma. If you wish to send the email to the user who generated the item, simply type the reserved word: \"user\". Enter WhatsApp numbers in the following format: wa:5491155443322, where it starts with \"wa:\" followed by a number that contains the country code, followed by the 9, the area code, and the phone number.",
				"ERR_PASTE_INVALID_BODY": "Pasted content must be a comma-separated list of contacts (emails, wa:+number, field:id, or reserved words such as user)."
			},
			"OPTIONS5_DIR": {
				"ERR_INVALID_TITLE": "Error: Invalid parameters",
				"ERR_INVALID_BODY": "The following values are invalid (plain text without spaces; letters, numbers, hyphen and underscore only; must start with a letter):",
				"ERR_INVALID_EDIT_BODY": "The edited value is invalid. It must be plain text without spaces, start with a letter, and use only letters, numbers, hyphen or underscore.",
				"ERR_DUPLICATE_TITLE": "Error: Duplicate parameter",
				"ERR_DUPLICATE_BODY": "The entered parameter already exists in the list."
			},
			"ELEMENT_DIR": {
				"ARCHIVED": "ARCHIVED",
				"ARCHIVE_ELEMENT": "Archive Element",
				"UNARCHIVE_ELEMENT": "Unarchive Element",
				"DELETE_ELEMENT": "Delete Element",
				"CLONE_ELEMENT": "Clone Element"
			},
			"SIMPLELIST_DIR": {
				"TEXT": "Text",
				"NUMBER": "Number",
				"ADDFIELD": "Add new property"
			},
			"ADVANCED_CONFIG": "Advanced Options",
			"CONDITIONS_GRAPH": {
				"NEW_RULE": "New Rule",
				"CONDITION_ERROR": "Complete Conditions",
				"INTEGRATION_NO_AND_OR": "Integrations only support simple rules. AND and OR are not applied.",
				"AND": "AND",
				"OR": "OR",
				"NESTED_RULES_MIN": "Must have at least two nested rules",
				"ITEM_VALIDATION": "Item validation",
				"ALL": "All",
				"FIELD": "Element",
				"VALUE": "Value",
				"VALUE_PLACEHOLDER": "Value to Compare",
				"VALUE_PLACEHOLDER_LIST": "Comma-separated values",
				"OPERATORS": {
					"EQUAL": "equal to",
					"DISTINT": "different from",
					"LESS": "less than",
					"GREATER": " greater than",
					"LESS_EQUAL": "less equal",
					"GREATER_EQUAL": " greater equal",
					"EXISTS": "exists",
					"NOT_EXISTS": "does not exist",
					"STARTS_WITH": "starts with",
          "ENDS_WITH": "ends with",
          "CONTAINS": "contains",
          "IN": "is in",
          "NOT_IN": "is not in",
          "BETWEEN": "between",
          "REGEXP": "regular expression",
          "IGNORE": "ignore"
				}
			},
			"ERROR_CONDITIONS": {
				"TITLE": "Error: Incomplete fields",
				"MESSAGE": "You must complete all fields for each condition."
			},
			"GROUP_CONDITIONS": {
				"INFO": "This section allows assigning dynamic options to the group field, based on the responses of other fields.",
				"ADD": "New condition",
				"PILL_CONDITION": "Applied conditions"
			},
			"DINAMIC_SELECT": {
				"INFO": "This section allows you to assign dynamic options to the selection field, based on responses from other fields.",
				"ADD": "New Condition"
			},
			"SELECT_OPTIONS": {
				"MAKE_DINAMIC": "Switch to Rule Choice Mode",
				"OPTIONS_DATA": "Define options based on field data values:",
				"OPTIONS_STATIC": "Set the options independently of the fields data;"
			},
			"DATASOURCE": {
				"OPTIONS": "Options",
				"FORM": "Form",
				"ACTION": "Action",
				"INTEGRATION": "Integration",
				"CONCATENATE": "Concatenate DS",
				"RELATION": "Link DS",
				"LEFT_RELATION": "Associate Secondary DS",
				"DS1": "DS 1",
				"DS2": "DS 2",
				"DS1_PRIMARY": "DS 1 (Primary)",
				"DS2_SECONDARY": "DS 2 (Secondary)",
				"RESULTING_FIELDS": "Resulting Fields",
				"CONCATENATE_DESCRIPTION": "DataSources to merge vertically (Column name matching)",
				"FORM_DESCRIPTION": "Form",
				"ACTION_DESCRIPTION": "Action",
				"ACTION_FILTERS_INFO": "Conditions used to filter the action responses:",
				"FORM_FILTERS_INFO": "Conditions used to filter the form items:",
				"INTEGRATION_FILTERS_INFO": "Conditions used to filter the integration items:",
				"ACTION_FILTER_CREATED_AT": "Created (createdAt)",
				"ACTION_FILTER_SYSTEM": "System",
				"ACTION_FILTER_METADATA": "Metadata",
				"ACTION_FILTER_RESPONSE": "Response parameters",
				"NO_ACTION_RESPONSE_PARAMS": "No columns defined",
				"NO_ACTION_WEBHOOKS": "The form has no webhook actions defined",
				"INTEGRATION_DESCRIPTION": "Integration",
				"ADDITIONAL_COLUMNS": "ADDITIONAL COLUMNS",
				"NEW_COLUMN_TITLE": "Title of new column",
				"NEW_COLUMN_CONTENT_FORMULA": "Content formula. Example row['price'] * 2",
				"NEW_COLUMN_CONTENT_FORMULA_2": "Content formula. For SubItems count: idcampo.subItemsCount",
				"ADD_COLUMN": "Add Column",
				"ADDITIONAL_REPROCESS_SCRIPT": "Additional reprocess script",
				"FILTERS": "Filters",
				"ELEMENT": "Element",
				"FORM_FIELDS": "Form Fields",
				"CONFIGURATION": "CONFIGURATION",
				"ONLY_LAST_VERSION": "Bring only last version of the column (default ID)",
				"RESULTSET": "ResultSet",
				"DATASOURCE": "DataSource",
				"DATASOURCE_OPTIONS": "DataSource",
				"DATASOURCE_FIELD": "DataSource Field",
				"ERROR_DS_PRE": "The following fields must be completed:",
				"ERROR_DS_TITLE": "Error: Incomplete Fields",
				"CLIC_COPY_CLIPBOARD": "Click to copy to clipboard"
			},
      "WORKFLOW_CONFIG": {
				"INTRO_LINE1": "Below you can configure a series of steps that require the participation of different users to complete this same form. This is the form loading workflow; if you want to define a workflow for the produced data, go to Actions and Reports",
				"INTRO_LINE2": "Each step will reference a checkbox element that will be automatically activated when delivery is made to the next user. This checkbox will enable the next section, which must be inside a group associated with the checkbox. N groups can be associated with that checkbox and they do not necessarily need to be in location order.",
				"BEHAVIOR": "Behavior",
				"DIGITAL_CERTIFICATION": "Digital Certification",
				"WORKFLOW": "Workflow",
				"PTW": "Work Permit",
				"INSTANCE_1": "Instance 1:",
				"INSTANCE": "Instance",
				"IDENTIFICATION": "Identification",
				"PTW_STEP_DEFINITIONS": ">Definitions",
				"PTW_STEP_ENABLES": ">Enables",
				"PTW_STEP_CLOSURE": ">Closure",
				"INITIAL_ACCESS_INFO": "Initial access will be granted to any user subscribed to the form, unless some condition is defined internally in the form.",
				"CREATED_BY_USER": "Created By User",
				"CREATED_BY_USER_TOOLTIP": "Read-only Text element where the request creator user will be automatically written: Miguel Garcia <mgarcia@example.com>",
				"DOCUMENT_DATE": "Document Date",
				"DOCUMENT_DATE_TOOLTIP": "Indicates the date on which the document will be used for scheduled activities. If left empty, the record creation date is used",
				"ENABLES_WORK": "Enables work",
				"LOCKS_EDITABLE_FIELDS": "Locks editable fields",
				"CHECKBOX_ACTIVATES_FIELDS": "Checkbox that activates fields",
				"CHECKBOX_ACTIVATES_FIELDS_TOOLTIP": "Must be a checkbox element hidden on mobile, which enables through a group the elements corresponding to the instance",
				"RESPONSIBLE_USER": "Responsible User",
				"RESPONSIBLE_USER_TOOLTIP": "Must be a select element whose option value is the id or ids, separated by comma: '65d8919dbbf829705c7f66a0|Miguel Garcia'",
				"ADD_INSTANCE": "ADD INSTANCE",
				"GLOBAL": "Global",
				"SCROLL_TO_STEP": "Automatically scroll to the checkbox that activates the instance.",
				"LOCK_SAME_USER": "Block interaction by the same user",
				"LOCATION": "Location",
				"LOCATION_TOOLTIP": "Geolocation field or text following the latitude,longitude format, for example: -39.0133, -69.5619",
				"REJECT_CHECK": "Reject checkbox",
				"FILTER_IDLE_DAYS": "Filter by Days of Inactivity",
				"REJECT_AUTOMATICALLY": "Reject Automatically",
				"REJECT_IDLE_DAYS": "Automatic Rejection by Days of Inactivity",
				"ALLOW_REJECT_ANY_STEP": "Allow rejection at any instance",
				"MEMBER_TYPE_LABEL": "Responsible users identified by:",
				"MEMBER_TYPE_EMAIL": "Email",
				"MEMBER_TYPE_USER_ID": "User Id",
				"EDITABLE_FIELDS": "Editable fields",
				"EDITABLE_FIELDS_PTW_SUFFIX": "before the instance marked by \"Enables Work\"",
				"ANY_INSTANCE": "At any instance",
				"PAGE": "Page",
				"MEASUREMENT": {
					"TITLE": "Digital Certification",
					"ID": "Id",
					"COMPANY": "Company/Contractor",
					"ASSET": "Asset",
					"AGREEMENT": "Contract/Agreement",
					"TYPE": "Type",
					"POINTS_LIST": "Simple List where Measurement Points are",
					"ITEM_TO_REJECT": "Previous Point Record to Reject",
					"POINT_ID": "Item identifier field within the list",
					"DATE": "Date",
					"SECTION": "Section",
					"FILTER_1": "Filter 1",
					"FILTER_2": "Filter 2",
					"FILTER_3": "Filter 3"
				}
			}
		},
		"DASH_ADMIN": {
			"TITLE": "Administration Console",
			"TENANTS_REGISTRADOS": "Registered Tenants",
			"TENANT": "Tenant",
			"MEMBERS": "Member",
			"ITEMS": "Items",
			"LASTITEMDATE": "Last item created",
			"DISABLED": "Disabled",
			"DELETE": "Delete",
			"DIAG_DEL_TENANT": {
				"TITLE": "Delete tenant",
				"BODY": "¿Wish to delete tenant {{tenantId}}. Are you Sure?."
			}
		},
		"CLIENTS": {
			"TITLE": "Manage your Sites",
			"NEW": "New Site",
			"REMOVE": "Remove Sites selected",
			"EDIT": "Edit Site",
			"NO_RECS": "Account does not have any sites. Create a new one.",
			"INFO": "The Sites module is directly related to the Tasks module, and needs to be populated with Site data if you want to manage users' tasks from the Field platform.",
			"COLS": {
				"ASSOCIATED": "Associated to",
				"NAME": "Name",
				"ADDRESS": "Address",
				"EMAIL": "Email",
				"PHONE": "Phone",
				"DETAIL": "Detail",
				"DETAIL_INFO": "Second Address",
				"LNG": "Longitude",
				"LAT": "Latitude",
				"IMPORTED": "Imported",
				"IMPORTED_ACRONYM": "Imp.",
				"OU": "Organizational Unit",
				"OU_ACRONYM": "O.U.",
				"OWNERS": "Site Administrators"
			},
			"DIAG": {
				"TITLE": "Delete Site",
				"BODY": "¿Wish to delete site {{clientName}}?"
			},
			"MULTIPLEDIAG": {
				"TITLE": "Delete Sites",
				"BODY": "Do you want to remove the selected sites?"
			},
			"IMPORT": {
        "ERROR_SITE_DATA": "Error in site data. Verify that the Address or Coordinates (Latitude and Longitude) are complete."
      }
		},
		"DATA": {
			"TITLE": "Data",
			"TITLE_INFO": "The column Delay (hs), represents the time elapsed between the creation of the form and the submission to the server expressed in hours.",
			"VIEWMAP": "See map",
			"VIEWTASK": "See Tasks",
			"ACTIONS": "Actions",
			"MORE_ACTIONS": "View more actions",
			"DOWNLOAD": "Download",
			"EXPORT_CSV": "Export to CSV",
			"EXPORT_XLSX": "Export to XLSX",
			"DOWNLOAD_PDF": "Download PDF",
			"DEL_SEL": "Delete Selected items",
			"VIEW_ARCHIVED": "View archived fields",
      "HIDE_ARCHIVED": "Hide archived fields",
      "RESET_FILTERS": "Reset Filters",
      "RESET_GRID_LAYOUT": "Reset Columns",
      "REFRESH_TABLE": "Refresh Files",
			"ERROR_DATE": "You must enter a date in YYYY-MM-DD format.",
			"COLS": {
				"USER": "User",
				"STARTED_AT": "Created",
				"CREATED_AT": "Uploaded",
        		"CLOSED_REC": "Closed",
				"DELAY": "Delay Upload (hs)",
				"DELAY_TOOLTIP": "Time elapsed between creating the form and sending it to the server, expressed in hours.",
				"LAST_STEP": "Last Instance",
				"NAME": "Name of Task",
				"SITE": "Site of Task",
				"DESCRIP": "Task Description"
			},
      "ACTION_PROCESSED": "Action processed",
      "PROCESS_ACTIONS": "Run Actions",
      "NO_ACTION_SELECTED": "No actions selected",
      "REPORT_PROCESSED": "Report processed",
      "PROCESS_REPORTS": "Run Reports",
      "NO_REPORT_SELECTED": "No reports selected"
		},
		"DASH_DEPT": {
			"NO_FORMS": "The department does not have any form. Please create one.",
			"NO_TEAM": "The department does not have any team.",
			"PLANIFICAR_TAREAS": "Plan Tasks",
			"DAY_TASKS": "Day tasks",
			"ADMIN_DEPTO": "The Administrator can define more than one Department Owner",
			"TAG_SYNC_ADMIN_DEPTO": "Import Supervisors",
			"TAG_SYNC_ADMIN_DEPTO_TOOLTIP": "Import supervisor and associated tags from Google Sheets",
			"TAG_SYNC_ADMIN_DEPTO_INFO": "Import supervisor and associated tags from a Google Sheets, automatically assigning the role to the user (email account) in the \"deptName\" department, and handling the creation and removal of tags associated with users.",
			"TAG_SYNC_ADMIN_DEPTO_EXAMPLE": "You can find the data at:",
			"TAG_SYNC_WARNING": "Are you sure you want to continue? Performing this action may delete important information.",
			"TAG_SYNC_IMPORT_SUCCESS": "Synchronization completed successfully: supervisors were assigned and tags were updated according to the Google Sheet configuration.",
			"ADD_OWNER": "Add Owner",
			"ADD_SUPERVISOR": "Add Supervisor",
			"ADD_OWNER_TEAM": "Add Owner to the Team",
			"ADD_USER_TAGS": "Tags",
			"TAGS_SYNC": "Tags Sync",
			"INFO_USERS_OWNER": "Search for the users you want to incorporate as owners",
			"ADD_USER": "Add Users",
			"ADD_SUPERVISOR_TEAM": "Add Supervisor to the Team",
			"NO_TAGS_DEPT": "The department has no tags",
			"NO_TAGS_DEPT_USER": "The department has no tags to assign to the user",
			"NO_TAGS_CHIP": "All tags have been assigned",
			"ERROR_TAG_USER_ASSIGN": "Error assigning tag to user",
			"ERROR_TAG_USER_UNLINK": "Error removing tag from user",
			"ERROR_TAG_DEPT_NEW": "Failed to create the tag",
			"ERROR_TAG_DEPT_MODIFY": "Failed to modify the tag",
			"INFO_USER_SUP": "Find the users you want to register as supervisors",
			"ADMIN": {
				"TITLE": "Owners of {{deptoName}}",
				"USERS": "Users",
				"INFO": "Department owners can create forms and teams and assign tasks",
				"NO_DEPTO_OWNER": "{{deptoName}} does not have any owner.",
				"INFO_2": "The owner of a Department has permission to enlist users, create forms, teams, sites, and tasks. The owner does not have permission to register other departments. That's why a Department Owner has to be registered by the Administrator, that is, the first user to register the Company Account in Field. The Administrator can define more than one Owner of a Department and in turn can give administrator role to other users. A Department Supervisor is only allowed to view and download data and reports.",
				"TAGS_MULTI": "Multiple Tags",
				"COLS": {
					"NAME": "Name",
					"EMAIL": "Email",
					"PRIVILEGES": "Privileges",
					"SUPERVISOR": "Supervisor",
					"OWNER": "Owner",
					"TAGS": "Tags"
				},
				"DIAG_DEL": {
					"TITLE": "Delete Owner",
					"BODY": "¿Wish to delete user {{ firstName }} {{ lastName }} as owner and / or supervisor of the group? You will not be able to manage / supervise the department or see its data."
				}
			},
			"DEPT_TAG": {
				"TITLE": "Department Tags",
				"ADD_TAG": "New Tag",
				"EDIT_TAG": "Edit Tag",
				"DIAG_DEL": {
					"TITLE": "Delete Tag",
					"BODY": "Deleting the tag will remove it from all items to which it is associated."
				}
			}
		},
		"DASH_DEPTS": {
			"NEW": "New Department",
			"TITLE": "Manage your Departments",
			"LABEL_NEW": "Enter the New Department",
			"INFO_1": "The account does not have any department. Please create one.",
			"INFO_2": "Before a user (field user; mobile app user) can start using the app, they must have first been assigned to a department. And for a department to be enabled, it is necessary to assign it an owner. Therefore, creating users is one of the first tasks to be performed after registering your account with Field. Obviously, the user who registered with Field is already a user and therefore, to use the mobile app, you only have to create a Department, register as the Owner of the same, create a work team and subscribe that team to the created Form.",
			"COLS": {
				"NAME": "Name",
				"FORMS": "Forms",
				"MEMBERS": "Members",
				"ADMIN": "Manage Department",
				"DELETE": "Delete Department"
			},
			"DIAG_DEL": {
				"TITLE": "Delete department",
				"BODY": "Deleting the department will delete all the information related to it."
			}
		},
		"DASH_GRAPH": {
			"DIAG_COPY": {
				"TITLE": "Copy graph",
				"QUESTION": "Do you want to create a copy of the graph?",
				"LABEL": "Destination Department:",
				"ACCEPT": "Copy graph",
				"ACTION_TYPE": "Copy mode",
				"NEW": "Generate a new Form",
				"OVERWRITE": "Overwrite destination with source",
				"UPDATE": "Add new fields, and archive non-existent ones",
				"FORM_TO": "Destination Form",
				"INFO": "Changes in field locations/settings will be overwritten from source to destination",
				"ICON_ARCHIVED": "Item archived",
				"ICON_ADD": "Field to be added to the destination",
				"ICON_DELETE": "Field to be deleted",
				"ICON_ARCHIVE": "Field that does not exist at source and will be archived at the end of the page"
			},
			"NEW": "New graph",
			"COPY_TEXT": "Copy of ",
			"IMPORT": "Import graph",
			"NOT_FOUND": "The graph was not found",
			"NO_INFO": "The department does not have any graphs. Please create one.",
			"DIAG_CREATE": {
				"TITLE": "New Board",
				"BODY": "Do you want to create a graph?"
			},
			"TOOLTIP_SUBS": "There are no teams subscribed to this graph",
			"TOOLTIP_EDIT": "Edit Board",
			"TOOLTIP_USERS": "Users",
			"TOOLTIP_DATA": "Data",
			"TOOLTIP_RPT": "Report Settings",
			"TOOLTIP_CP": "Copy",
			"TOOLTIP_API": "API url(beta)",
			"TOOLTIP_WH": "Subscribe to webhook",
			"DIAG_DEL": {
				"TITLE": "Delete Board",
				"BODY": "By deleting the graph you will no longer have access to the data generated by it."
			},
			"DIAG_IMPORT": {
				"TITLE": "Import Graph",
				"FORM_NAME": "Graph name",
				"SELECT": "Select File",
				"ACCEPT": "Import",
				"FILE_VALID": "Error reading JSON file. Please ensure the file is in a valid format.",
				"FILE_WITHOUT_GRAPH": "The entered file does not contain a graph",
				"MISSING_DS": "You must complete all form and integration fields",
				"NO_NAME": "The graph has no name",
				"PAGE_WITHOUT_ELEMENTS": "Page {{page}} has no elements",
				"CREATE_FAILED": "Error creating the graph",
				"CREATE_NO_ID": "The graph was created but no valid identifier was returned",
				"OPEN_FAILED": "The graph was imported but could not be opened"
			},
			"DIAG_EXPORT": {
				"TITLE": "Export",
				"BODY": "The changes made to the graph will be saved.<br><br><strong>Warning:</strong> If you want to import this Dashboard into another Department, you must ensure that the Forms and Integrations used in it are exported and imported into the corresponding Department.",
				"ACCEPT": "Continue"
			},
			"REFERENCE_COLORS": "Reference Colors",
			"REFERENCE_COLORS_INFO": "Define the colors associated with the references used in the dashboard charts.",
			"AXIS_SCALE": "Scale type",
			"AXIS_SCALE_AUTO": "Automatic",
			"AXIS_SCALE_LINEAR": "Linear",
			"AXIS_SCALE_LOG": "Logarithmic",
			"AXIS_SCALE_DATE": "Date",
			"AXIS_SCALE_CATEGORY": "Category",
			"AXIS_SCALE_LOG_HINT": "Logarithmic scale does not show values less than or equal to zero.",
			"AXIS_Y": "Y axis",
			"AXIS_X": "X axis",
			"AXIS_TITLE": "Title",
			"TICK_FORMAT": "Value format",
			"TICK_AUTO": "Automatic",
			"TICK_INTEGER": "Integers",
			"TICK_DECIMAL": "Decimals",
			"TICK_CURRENCY": "Currency",
			"TICK_PERCENT": "Percentage",
			"TICK_MONTH_YEAR": "Month / Year",
			"TICK_YEAR": "Year",
			"TICK_MONTH": "Month",
			"AXIS_MIN": "Minimum",
			"AXIS_MAX": "Maximum",
			"DATA_SET": "Data set",
			"DATA_ORDER_TOP": "First",
			"DATA_ORDER_LAST": "Last",
			"DATA_QUANTITY": "Quantity",
			"PANEL_BACKGROUND": "Panel background color",
			"HIDE_TITLE_BAR": "Hide title bar",
			"SIZE_WIDTH": "Width",
			"SIZE_HEIGHT": "Height",
			"SIZE_FRACTION": "Fraction",
			"SIZE_PERCENTAGE": "Percentage",
			"SIZE_PERCENTAGE_PLACEHOLDER": "Percentage (0-100)",
			"LOGO_POSITION": "Logo position",
			"TEXT_ALIGN": "Text alignment",
      "GRID": {
        "RESET_FILTERS_TOOLTIP": "Reset Filters",
        "RESET_COLUMNS_TOOLTIP": "Reset Columns",
        "VIEW_MODE_TOOLTIP": "View Mode",
        "EDIT_MODE_TOOLTIP": "Edit Mode",
        "REFRESH_TOOLTIP": "Refresh Chart",
        "DOCS_FILTER_WITH": "With Docs",
        "DOCS_FILTER_WITHOUT": "No Docs"
      }
		},
		"DASH_FORM": {
			"TEAMS": {
				"TITLE": "Teams",
				"TITLE_1": "Subscribe teams to the form",
				"NO_INFO": "The department does not have any team.",
				"NO_INFO_1": "Please create one in the Teams section.",
				"COLS": {
					"NAME": "Name",
					"DESCRIP": "Description",
					"MEMBERS": "# members",
					"STATE": "State"
				},
				"ADD_TEAM": "Team Enrolled",
				"ADD_TEAM_ERR": "Failed to enrol team",
				"REMOVE_TEAM": "Team Removed",
				"REMOVE_TEAM_ERR": "Error when Team Removal"
			},
			"DIAG_QR": {
				"QR_READ": "By scanning this QR code on your mobile, you'll have direct access to the form."
			},
			"DIAG_COPY": {
				"TITLE": "Copy Form",
				"QUESTION": "¿Wish to Copy Form?",
				"LABEL": "Department?:",
				"ACCEPT": "Copy Form",
				"ACTION_TYPE": "Copy mode",
				"NEW": "Generate a new Form",
				"OVERWRITE": "Overwrite destination with source",
				"UPDATE": "Add new fields, and archive non-existent ones",
				"FORM_TO": "Destination Form",
				"INFO": "Changes to field locations/settings will be overwritten from source to destination",
				"ICON_ARCHIVED": "archived item",
				"ICON_ADD": "Field to be added in the destination",
				"ICON_DELETE": "Field to be removed",
				"ICON_ARCHIVE": "Field that does not exist in origin and that will be archived"
			},
			"NEW": "New Form",
			"IMPORT": "Import Form",
			"EXPORT": "Export",
			"NO_INFO": "The department does not have any form. Please create one.",
			"DIAG_CREATE": {
				"TITLE": "New Form",
				"BODY": "Do you wish to create a new form(report)?"
			},
			"DIAG_IMPORT": {
				"TITLE": "Import Form",
				"FORM_NAME": "Form name",
				"SELECT": "Select File",
				"ACCEPT": "Import",
				"FILE_VALID": "You must enter a valid file",
				"FILE_WITHOUT_FORM": "The entered file does not contain a form",
				"REVIEW": {
					"TITLE": "Review before importing",
					"INTRO": "The form will still be created. This remains pending in this tenant:",
					"USERS": "There are {{count}} validators assigned by user in the source tenant. They need to be assigned again.",
					"TAGS": "Validation depends on tags from the source tenant. Those tags must exist here.",
					"EXTERNAL": "These integrations still point to files or services from the source: {{names}}.",
					"SHEETS": "These integrations read internal spreadsheets from the source, which do not exist here: {{names}}.",
					"GOOGLE": "These integrations read an external Google Sheet: {{names}}.",
					"NO_URL": "These integrations have no URL. Review them after importing: {{names}}.",
					"LOGO": "The report logo is a file from the source tenant and may not be visible.",
					"GRAPH": "It is linked to a graph that is not included in the file.",
					"TEAMS": "Teams are not imported. The form needs to be subscribed again."
				},
				"INTEGRATIONS_TITLE": "Integrations",
				"INTEGRATIONS_HELP": "If it already exists in this tenant, select it. Otherwise, you can create a new one.",
				"INTEGRATION_REUSE_ID": "It already exists in this tenant and will be reused.",
				"INTEGRATION_CREATE": "Create new",
				"INTEGRATIONS_LOADING": "This tenant's integrations are still loading.",
				"MISSING_INTEGRATION": "Select an existing integration or create a new one for {{name}}.",
				"SUMMARY_TITLE": "Form integrations",
				"SUMMARY_CREATED": "Created: {{names}}.",
				"SUMMARY_REUSED": "Reused: {{names}}.",
				"NO_NAME": "The form has no name",
				"PAGE_WITHOUT_ELEMENTS": "Page {{page}} has no elements",
				"INTEGRATION_ID_MISMATCH": "Integration ID {{id}} in the form does not match any integration in the file.",
				"INTEGRATION_CREATE_ERROR": "Error creating the integration: {{message}}",
				"IMPORT_ERROR": "Error importing the form"
			},
			"DIAG_EXPORT": {
				"TITLE": "Export",
				"BODY": "The changes made to the form will be saved",
				"ACCEPT": "Continue"
			},
			"TOOLTIP_SUBS": "There are no teams subscribed to this form",
			"TOOLTIP_EDIT": "Edit Form",
			"TOOLTIP_USERS": "Users",
			"TOOLTIP_DATA": "Data",
			"TOOLTIP_RPT": "Report Settings",
			"TOOLTIP_CP": "Copy",
			"TOOLTIP_API": "API url(beta)",
			"TOOLTIP_WH": "Subscribe to webhook",
			"SHOW_ARCHIVED": "View Archived",
			"ARCHIVE_FORM": "Archive form",
			"UNARCHIVE_FORM": "Unarchive form",
			"DIAG_DEL": {
				"TITLE": "Delete Form",
				"BODY": "By deleting the form you will no longer have access to the data generated by it."
			},
			"REPORT": {
				"SIGN_DOCUMENT": "Document with electronic signature",
				"BLOCKCHAIN_CERTIFICATE": "Certify transaction in blockchain",
				"TITLE": "Report Configuration",
				"TITLE_DEPT": "Configure Department Report Template",
				"SHOW_FIELDS": "Fields to show",
				"DEPT_REPORT_CONFIG": "Apply Template",
				"SEL_LOGO": "Select a logo",
				"LOGO": "Logo",
				"LOGO_CONFIG": "Configure logo",
				"HAS_IMAGE": "Has image",
				"NO_IMAGE": "No image",
				"IMAGE_NOT_FOUND": "Image not found",
				"LOGO_URL": "LOGO URL",
				"COPY_URL": "Copy URL",
				"URL_COPIED": "URL copied",
				"URL_COPY_ERROR": "Could not copy the URL",
				"WATERMARK": "Watermark",
				"WATERMARK_CONFIG": "Configure watermark",
				"WATERMARK_IMAGE": "Select an image",
				"WATERMARK_POSITION": "Position",
				"WATERMARK_SIZE": "Size",
				"WATERMARK_OPACITY": "Opacity",
				"WATERMARK_PREVIEW": "Preview",
				"NUMBER_COLSGRID": "Show in Columns",
				"SHOW_TITLE": "Show Title",
				"UPPER_LABELS": "Force Uppercase",
				"UNDERLINE": "Separator Line",
				"DRAW_ASTABLE": "Draw as Table",
				"HIDE_LABEL": "Hide label",
				"IN_NEW_PAGE": "In new page",
				"SHOWCASE": "Print Showcase",
				"SHOWCASE_IMG": "Image Maximum Height",
				"SL_HIDEHEADERS": "Hide",
				"TEXTALIGN": "Align field",
				"HIDE": "Ocult",
				"TAB_VALUES": "Tabulated values",
				"PRINT_HEADERFOOTER": "Print Header(Department-FormName-Date-UserName) and Footer(NroPage)",
				"SHOW_AS_ATTACHED": "Maps and Photos as attachments at the end of the report",
				"VALUE_AS_ATTACHED": "Show as attached",
				"COLSPAN": "Expand Columns",
				"ROWSPAN": "Expand Rows",
				"ROTATE_LABEL": "Rotate header",
				"ROTATED_HEIGHT": "Height",
				"COLSPAN_INFO": "according to report columns",
				"MAXHEIGHTPHOTOINFORM": "Maximum height of photos/Maps in form(cm)",
				"GEO_TIMESTAMP": "Show Geolocation Date Time",
				"GEO_PRECISION": "Show Geolocation precision",
				"SHOWAS_QR": "Show value as QR",
				"QR_SIZE": "Show value as QR",
				"QR_SHOWVALUE": "Show value",
				"INTERLINE": "Interline",
				"CSS_TITLE": "Advanced CSS Settings",
				"CSS_CELL": "CSS CELL",
				"CSS_LABEL": "CSS LABEL",
				"CSS_VALUE": "CSS VALUE",
				"SHOW_DESCRIP": "Show description",
				"SHOW_DATE": "Show date and time of the report",
				"SHOW_INSPECTOR": "Show inspector name",
				"BOLD_TITLE": "Bold Labels",
				"SHOW_MAP": "Show map in geolocation field",
				"SHOW_MAP_SAT": "Show map in satellite mode",
				"COLSXROWS": "Reverse columns by rows in Simple List",
				"VALIDATE_REQUIRED": "Show Validations",
				"PAGE_SIZE": "Page size",
				"PAGE_SIZE_LETTER": "Letter",
				"PAGE_ORIENTATION": "Page Orientation",
				"PAGE_ORIENTATION_1": "Landscape",
				"PAGE_ORIENTATION_2": "Portrait",
				"FONT_SIZE": "Font size",
				"FONT_SIZE_O1": "Small",
				"FONT_SIZE_O2": "Medium",
				"FONT_SIZE_O3": "Large",
				"Q_PHOTOS": "Number of photos per row",
				"FORMAT_RPT": "Report format",
				"FORMAT_RPT_O1": "Default",
				"FORMAT_RPT_O2": "Two columns",
				"FORMAT_RPT_O3": "Custom",
				"AUTO_SEND": "Sending Automatic Reports",
				"CONDITIONAL_EMAILS": "Advanced",
				"ACTIONS_SEND": "Actions",
				"EMAIL_INFO_1": "To send to the user who uploaded the record, enter ",
				"EMAIL_INFO_2": "; it will be replaced with their user email.",
				"WA_INFO_1": "or if you want to label it",
				"WA_INFO_2": "receiver1",
				"EMAIL_KEY_USER": "user",
				"INFO_1": "Next you will be able to configure an email list. Those addresses that you configure will receive an email each time an element is uploaded to the database, with the corresponding PDF report attached.",
				"INFO_2": "Then you can configure a list of emails depending on the values ​​that are loaded in the form. Those addresses that you configure will receive an email every time an element is loaded into the database, with the report in Corresponding PDF attached.",
				"LBL_SAVEINFO": "You have unsaved changes.",
				"LBL_CONFIG_OK": "Configuration saved",
				"LBL_LOGO_OK": "File Uploaded",
				"SEL_FIELDS": "Select fields",
				"SEL_FIELDS_INFO": "Drag to the right column the fields to show in the report",
				"SEL_FIELDS_ADD_ALL": "Add all",
				"SEL_FIELDS_REMOVE_ALL": "Remove all",
				"ADD_ALL_DIALOG": {
					"TITLE": "Add all fields",
					"BODY": "You already have fields in the right column. Adding all will reorder the list according to the form order and your current custom order will be lost. Do you want to continue?"
				},
				"DEPT_REPORT_DIALOG": {
					"TITLE": "Report: Template",
					"BODY": "The current configuration will be replaced with the department's template configuration.",
					"BODY2": "The report configuration of pre-existing forms will not be automatically modified. Changes will need to be made manually."
				},
				"INSERT_VALUE": {
					"BODY": "Table Header (HTML)",
					"FOOTER": "Table Footer (HTML)",
					"BODY_PLACEHOLDER": "Default Message",
					"EMPTY_SPACE": "Value for empty fields",
					"TABLE_LAYOUT": "Page as Table"
				}
			},
			"ACTIONS": {
				"ACTIONS_TITLE": "ACTIONS",
				"INFO_1": {
					"INFO_1": "This functionality allows extending the ",
					"INFO_2": "workflow to external elements ",
					"INFO_3": "of the form. These ",
					"INFO_4": "ACTIONS ",
					"INFO_5": "can be sending a ",
					"INFO_6": "report via email",
					"INFO_7": ", a notification via ",
					"INFO_8": "WhatsApp",
					"INFO_9": ", creating ",
					"INFO_10": "new tasks ",
					"INFO_11": "within Field by connecting other users and/or forms, or integrating with ",
					"INFO_12": "external systems ",
					"INFO_13": "via Webhooks, such as creating an event in a ticket system.",
					"INFO_14": "The execution of these Actions can be set based on a trigger (new, validation, record deletion) and/or based on conditions met in the data collected in the form."
				},
				"INFO_2": {
					"INFO_1": "No actions defined",
					"INFO_2": "Each action is built with 3 steps: A trigger, conditions or filters, and finally the action to be performed.",
					"INFO_3": "Trigger: ",
					"INFO_4": "These are events on records that initiate the evaluation process of the action or workflow.",
					"INFO_5": "Conditions: ",
					"INFO_6": "They allow determining when to continue with the workflow, based on the values of the record. You can create filters by selecting a field with the corresponding operator and value, combining conditions using logical operators and and or.",
					"INFO_7": "Actions: ",
					"INFO_8": "The final step of the workflow, where it is indicated what should be done with the data record."
				},
				"INFO_REPORT": {
					"INFO_1": "Automatic Report Delivery",
					"INFO_2": "Below you can configure a list of emails. Those addresses you configure will receive an email each time an item is loaded into the database, with the corresponding PDF report attached."
				},
				"INFO_ACTIONS": "Below you can configure a list of actions that will be executed based on the operations performed with the forms.",
				"ACTION_TITLE": "Action No.",
				"ERROR_FIELDS_TITLE": "Error: Incomplete Form",
				"ERROR_ACTIONS_PRE": "The following errors were found:\n",
				"ERROR_REQUIRED_FIELD": "is a required field.",
				"ERROR_REQUIRED_CONDITIONS": "all fields in the added conditions must be completed.",
				"FIELDS": {
					"NAME": "Name",
					"DESCRIP": "Description",
					"INIT_WHEN": "1. Initiate when there is:",
					"DATA_MATCH": "2. And the data matches:",
					"ACTION_TODO": "3. Perform the following action:",
					"ACTION_EMAIL": {
						"SUBJECT": "Subject / Message",
						"SUBJECT_TOOLTIP": "Email Subject and/or WhatsApp Message",
						"SUBJECT_PLACEHOLDER": "Default subject",
						"BODY": "Message Body (Email)",
						"BODY_PLACEHOLDER": "Default message",
						"EMPTY_VALUE": "Value for empty fields",
						"EMPTY_VALUE_PLACEHOLDER": "E.g. **",
						"EMPTY_VALUE_TOOLTIP": "Text shown in the message body when an inserted field has no value.",
						"LOAD_HTML_EDITOR": "Load HTML Editor",
						"REPORT": "Report",
						"RECIPIENTS": "Recipients",
						"INSERT_VALUE": "Insert Value"
					},
					"ACTION_WEBHOOK": {
						"ACTIONREPEATSIMPLELIST": "Repeat action for each row in the list",
						"ACTIONREPEATNUMBER": "If I associate a simple list, it indicates the repetition number here to call the respective row.",
						"TITLE_H3": "Reference to the entered record",
						"_CREATEDAT": "Date and time when it was uploaded to the server. DateTime UTC String format.",
						"_STARTEDAT": "Date and time when the record was started. DateTime UTC String format.",
						"CLOSEDAT": "Date and time when the record was closed. DateTime UTC String format.",
						"OTHER_ATTRIBUTES": "Other attributes with specific values.",
						"PHONEINFORMATION": "Object containing phone information.",
						"VALIDATE": "Array of objects with validation instances performed by the supervisor.",
						"MEMBER": "Object representing the user who uploaded the record.",
						"FORM": "Object describing the form.",
						"FORM.NAME": "Form name.",
						"FORM.ID": "Form identifier.",
						"FORM.OTHER_ATTRIBUTES": "Other attributes related to the form.",
						"PAYLOAD": "Object containing data collected in the form by the operator.",
						"PAYLOAD_DESCRIPTION": "Each is accessed through the field id and share the following attributes:",
						"PAYLOAD.ID": "Element identifier.",
						"PAYLOAD.TYPE": "Element type (select, number, populate, text).",
						"PAYLOAD.NAME": "Element name.",
						"PAYLOAD.VALUE": "Element value.",
						"PAYLOAD.PAGE": "Page number associated with the element.",
						"PAYLOAD_FIELDS": "The identifiers for the fields are:",
						"RESPONSE_PARAMS": "Response parameters",
						"RESPONSE_PARAMS_PLACEHOLDER": "E.g.: status, ticketId",
						"RESPONSE_PARAMS_HELP": "Parameter names returned by the webhook. Plain text without spaces (letters, numbers, hyphen and underscore). Comma-separated."
					},
          "ACTION_CERTIFY_PDF": {
            "CONTACT_SUPPORT": "Please contact the Field Support team to define your Wallet and Contract."
          },
					"FILTERS": "Filters"
				},
				"TRIGGER_LIST": {
					"NEW_RECORD": "New Record",
					"VALIDATE": "Validation OK / Rejected",
					"VALIDATE_OK": "Validation OK",
					"VALIDATE_REJECT": "Validation Rejected",
					"DEL_RECORD": "Record Deletion"
				},
				"ACTIONS_LIST": {
					"EMAIL": "Send Reports (Emails/WhatsApp)",
					"WEBHOOK": "WebHook Activation",
          "CERTIFY_PDF": "Certify Transaction in Blockchain",
					"TASK": "Task Generation (Request Form Completion)"
				},
				"REPORT_LIST": {
					"NONE": "Do Not Send",
					"PDF_ATTACHMENT": "Default PDF attachment",
					"HTML_ATTACHMENT": "Default HTML attachment",
					"HTML_EMBEDDED": "Default HTML in message body"
				},
				"DELETE_ACTION": "Delete Action",
				"ADD_ACTION": "New Action",
				"CLONE_ACTION": "Clone Action",
				"DISABLE_ACTION": "Disable action",
				"ENABLE_ACTION": "Enable action",
				"STATE_ACTIVE": "Active",
				"STATE_INACTIVE": "Inactive",
				"ERROR_CONVERT_TITLE": "Data Conversion",
				"ERROR_CONVERT_BODY": "The form conditions have been converted into actions. Edit and accept the changes to save them."
			},
			"OTHERS_CONFIG": {
				"ELEMENT_TYPE": "Element Type",
				"CHANGE_TYPE": "Change Type to",
				"PRESET": "Preset",
				"HIDE_GRID_TITLE": "Visibility in Grids",
				"HIDE_GRID": "Hide Item",
				"WITHOUT_REVISION": "Does not require user review",
				"METADATA": "METADATOS",
				"METADATA_INFO": "Information associated with the form required when consuming the API or WebHook (Key-Value)"
			}
		},
		"DASH_INTEG": {
			"SAVE": "Save Integration",
			"EXPORT": "Export Integration",
			"IMPORT": "Import Integration",
			"ASSOCIATED_FORMS": "Associated Forms",
			"NO_ASSOCIATED_FORMS": "No associated forms.",
			"ASSOCIATED_FORMS_ERROR": "Could not load associated forms.",
			"FORM_INTEGRATIONS_TITLE": "Integrations used in the form",
			"FORM_VALIDATE_INTEGRATIONS_TITLE": "Integrations used in form validation",
			"NO_FORM_INTEGRATIONS": "This form is not using any integrations.",
			"FORM_INTEGRATIONS_ERROR": "Could not load the integrations used in this form.",
			"INTEGRATION_DELETED": "Integration deleted",
			"INTEGRATION_DELETED_LABEL": "DELETED",
			"OPEN_ALL": "Open all Integrations",
      "SAVE_FIRST": "You must save the integration first",
      "URL_TAB_CHANGE_CONFIRM_TITLE": "Change connection type",
      "URL_TAB_CHANGE_CONFIRM_MESSAGE": "Changing the connection type will clear all integration configuration (URL, parameters, authentication, response mapping, etc.). Do you want to continue?",
      "GLOBAL": "Global",
			"FIELDS": {
				"DEPT": "Associate Department",
				"SITE": "Associated Site",
				"URL_TYPE": {
          "FORM": "Form Field",
          "VOOLKS_SHEET": "Voolks Sheet",
          "S3": "Field S3",
          "GOOGLE": "Google Sheet",
          "STANDARD": "Standard",
          "AI": "AI"
        },
        "AI": {
          "MODEL": "Model",
          "MODEL_LITE": "Document and form analysis",
          "MODEL_PRO": "Images and geometric shapes",
          "PROMPT": "Prompt",
          "PROMPT_PLACEHOLDER": "Connection prompt",
          "ONLY_POPULATE": "Autocomplete integration type only",
          "TYPE_HELP": "AI can only be used with Autocomplete.",
          "DYNAMIC_PARAMS_HELP": "These fields are associated with an element in the form and will use the data entered in it. For AI, one of these parameters is expected: base64Data, mediaType, mimeType.",
          "POPULATE_DESCRIPTION": "Description"
        },
        "VOOLKS_SHEET_MODE": {
          "SIMPLE": "Simple",
          "ADVANCED": "Advanced"
        },
        "GOOGLE": {
          "ERROR": "Could not access information. Check credentials and file permissions.",
          "ASSISTANT": "Assistant",
          "SHEET_ID": "Google Sheet ID:",
          "SHEET_NAME": "Sheet Name (SheetName):",
          "LOAD_BOOK_SHEETS": "Load workbook sheets",
          "SELECT_BOOK_SHEET": "Select a sheet",
          "GET_SHEET_COLUMNS": "Get sheet columns",
          "GET_COLUMNS": "Get Columns",
          "VALUE_LABEL_TOOLTIP": "Name used to expose the value to the form and the sheet column.",
          "FIRST_VALUE_IS_TITLE": "First value is title",
          "SIMPLE_LIST": "Simple list",
          "SORT_ALPHABETICALLY": "Sort alphabetically",
          "LIST": "List",
          "ID_PARSE_ERROR": "Could not get the Google Sheet ID from the URL.",
          "LOAD_SHEETS_FIRST": "Load the sheet names first using the refresh button.",
          "SHEETS_LOADED": "Sheet names loaded successfully.",
          "COLUMNS_LOADED": "Columns loaded successfully."
        },
        "STANDARD": {
          "URL_PLACEHOLDER": "http://127.0.0.1/webservice/mydata, leave empty if downloading data is not required",
          "UPLOAD_FILE": "UPLOAD FILE",
          "UPLOAD_FILE_FIRST_SAVE": "To upload a file, first create the integration and then file upload will be enabled.",
          "UPLOADING_FILE": "Uploading file..."
        },
        "VOOLKS_SHEET": {
          "BOOK_NAME": "Workbook name:",
          "OPEN_BOOK_TOOLTIP": "Open workbook in Voolks Sheet",
          "SELECT_BOOK": "Select a workbook",
          "SHEET": "Sheet:",
          "SELECT_SHEET": "Select a sheet",
		  "IMPORTANT_INFO": "Notice: Please remember that the sync time between the sheet and integrations is 5 minutes after the last change."
        },
        "S3": {
          "TABLE_NAME": "Table name",
          "SEPARATOR": "Separator",
          "DATA_TYPE": "Data type",
          "PRIMARY_KEY": "Primary key",
          "INDEX": "Index",
          "COLUMN_ALREADY_EXISTS": "The column already exists",
          "TYPE_INTEGER": "INTEGER",
          "TYPE_REAL": "REAL",
          "TYPE_TEXT": "TEXT"
        },
        "EDITOR": {
          "DATA": "Data",
          "PARAMS": "Params",
          "PARAMS_TITLE": "PARAMS:",
          "SAVE_CHANGES_HINT": "Save changes first so they are reflected.",
          "FORMAT_DOCUMENT": "Format Document",
          "RETURN_VALUE": "Return Value"
        },
				"AUTH": {
					"TITLE": "Authorization ",
					"TYPE": "Authentication Type",
					"ACCESSKEY": "Access Key",
					"SECRETKEY": "Secret Key",
					"REGION": "Region",
					"SERVICE ": "Service",
          "OPTION_NONE_PUBLIC": "NONE | No Authentication | Public",
          "OPTION_USER_TOKEN": "Voolks UserToken",
          "OPTION_AWS_SIGNATURE": "AWS Signature",
          "OPTION_MSAL": "Microsoft Authentication Library",
          "OPTION_GOOGLE_APIS": "Google Cloud Platform (GoogleApis)",
          "GOOGLE_HELP_1": "If you want to use Field's service account, grant permissions to user: fieldapi@fieldglobal.iam.gserviceaccount.com and leave the credentials field below empty.",
          "GOOGLE_HELP_2": "If you want to create your own service account, here is the reference with the required steps:",
          "GOOGLE_OAUTH_LINK_LABEL": "OAUTH GOOGLE",
          "GOOGLE_HELP_3": "Then paste the generated JSON file content into the following field.",
          "CREDENTIALS_JSON_CONTENT": "CREDENTIALS JSON CONTENT",
          "CLIENT_ID": "Client ID",
          "TENANT_ID": "Tenant ID",
          "CLIENT_SECRET": "Client Secret"
				},
				"PARAM_URL": "If the parameters are to be assigned to the URL, they must be enclosed in slashes /Parameter1/. The name of the parameters is arbitrary and must be unique within the URL.<br> Example<br><b>URL</ b>:https://www.miapp.com/cat/<i>categoryNumber</i>/prod/<i>productnumber</i>?order=descrip<br> <b>Parameters</b>< ul><li>/categoryNumber/</li><li>/productnumber/</li></ul><br> Example 2<br><b>URL</b>https://graph.microsoft. com/v1.0/users?$count=true&$search=\"displayName:<i>{displayName}</i>\"&$orderBy=displayName&$select=displayName,mail<br> <b>Parameters< /b><ul><li>{displayName}</li></ul>",
				"DATA": "Basic data",
				"TYPE": "Integration type",
				"TYPE_GET": "Bring data",
				"TYPE_VALIDATE": "Validate",
				"TYPE_AUTO": "Autocomplete",
				"NAME": "Name",
				"DESCRIP": "Description",
				"CONFIG": "Configure connection",
				"URL": "URL",
				"COPY_URL": "Copy URL",
				"COPY_URL_OK": "URL copied",
				"COPY_URL_ERROR": "Could not copy the URL",
				"FORM_FILTER": {
					"UPLOADED": "Uploaded",
					"CREATED": "Created",
					"CLOSED": "Closed",
					"FORM": "Form",
					"PAGE": "Page",
					"LAST_VALIDATION": "Last Validation",
					"VALIDATION_DATE": "Validation Date",
					"VALIDATION_STATE": "Validation State",
					"VALIDATION_FROM": "Validation From",
					"VALIDATION_UNTIL": "Validation Until",
					"VALIDATOR": "Validator",
					"APPROVED": "Approved",
					"REJECTED": "Rejected",
					"NOT_PENDING": "Approved/Rejected",
					"PENDING": "Pending"
				},
        "SELECT_OPTION_GLOBAL": "GLOBAL",
				"FORMAT_REQUEST": "Data Format Request",
				"FORMAT": "Data Format Response",
        "METHOD_GET": "GET",
        "METHOD_POST": "POST",
        "FORMAT_REQUEST_DATA": "DATA",
        "FORMAT_REQUEST_JSON_BODY": "JSON BODY",
        "FORMAT_JSON": "JSON",
        "FORMAT_XML": "XML",
        "FORMAT_TEXT": "TEXT",
        "FORMAT_ARRAY": "ARRAY",
				"METHOD": "Method",
				"ROWS": "Number of Records",
				"ALLOW_OFFLINE": "ALLOW OFFLINE",
				"ALLOW_OFFLINE_TOOLTIP": "Download the data from the URL at the time of synchronizing the app. The parameters that it sends are only the static ones, and the authorization is obtained at that moment.",
				"REFRESH_OFFLINE": "Do not sync before ",
				"REFRESH_OFFLINE_TOOLTIP": "It does not download the information from the website again before the indicated hours have passed. To force the deadline, the user must log out to the app and log in again. If set to zero it will only be downloaded at login time",
				"ADDPARAMS": "Add parameters to header",
				"PH_DEFAULT": "Value by default",
				"PH_HEADER": "Header",
				"PH_VALUE": "Value",
				"PH_ACTIVE": "Active",
        "PH_OP": "Operation",
        "PH_FIELD": "Column",
				"PARAM": "Parameter",
        "PARAM_NAME_REQUIRED": "Enter a name for the parameter.",
        "PARAM_COLUMN_SHEET": "Values returned",
				"PARAM_STATIC": "Static Parameters",
				"PARAM_STATIC_TOOLTIP": "These fields are defined from this interface. In the case of using keywords, they will be replaced by the corresponding value: {currentUser.Email}",
				"PARAM_DYNAMIC": "Dynamic Parameters",
				"PARAM_DYNAMIC_TOOLTIP": "These fields are associated with an element in the form and will use the data entered in it.",
				"VALS_AUTO": "Values ​​returned by autocomplete",
				"TT_VALS_AUTO": "Enter the fields returned by the web service with which you want to complete elements of the form.",
				"AFTERHOOK": "AfterHook",
				"AFTERHOOK_I1": "This function is executed after requesting the web service. In this way it is possible to modify the data and adapt it to the structure required by the integration and its use in the forms..",
				"AFTERHOOK_I2": "It has a maximum execution time of 10ms and receives as the first argument the data returned by the request and as the second the dynamic parameters sent.",
				"AFTERHOOK_I3": "The function must return the correct format (array, boolean or a javascript object with a defined structure).",
				"AFTERHOOK_I4": "If the request expects an XML string, it will be converted to a JS object before passing it to the function.",
        "AFTERHOOK_LIBRARY_TITLE": "Function library",
        "AFTERHOOK_LIBRARY_FIND_FIELD": "Gets the element inside the record, useful when reading other records generated in FIELD.",
        "AFTERHOOK_LIBRARY_GSHEET_LIST": "Returns the list of data from a column for Google Sheet integrations.",
        "AFTERHOOK_LIBRARY_CSV_TABLE": "Returns a table to process for CSV file integrations.",
        "AFTERHOOK_LIBRARY_CSV_LIST": "Returns the list of data from a column for CSV file integrations.",
        "AFTERHOOK_LIBRARY_GPS_DISTANCE": "Distance calculation, returns kilometers between two GPS coordinates."
			},
      "MODALS": {
        "EXAMPLE": {
          "FIND_DATA": "You can find the data at:"
        },
        "GOOGLE_ASSISTANT": {
          "TITLE": "Get parameters from URL",
          "URL_PLACEHOLDER": "https://sheets.googleapis.com/v4/spreadsheets/... or https://docs.google.com/spreadsheets/d/..."
        },
        "GOOGLE_SHEET_NAMES": {
          "SELECT_SHEET": "Select sheet",
          "AVAILABLE_SHEETS": "Available sheets"
        },
        "S3": {
          "SQLITE_CONNECTION_DESC": "Connection to SQLite with data from SFTP received in the \"data\" table.",
          "MOBILE_ONLY_DESC": "Visible only on mobile. Requires a file received from SFTP.",
          "USAGE_EXAMPLE": "Usage example:",
          "NOTE_LABEL": "Note:",
          "NOTE_TEXT": "This feature is designed to work with large volumes of data on mobile devices."
        },
        "DATA_ERROR": {
          "RESPONSE_API": "RESPONSE API"
        },
        "DATA_SUCCESS": {
          "RETURN_VALUES": "RETURN VALUES:"
        }
      },
			"TITLE": "Manage Your Integrations",
			"NEW": "New Integration",
			"COPY_TEXT": "Copy of ",
			"TITLE_1": "Integrations",
			"NO_INFO": "There is no integration. Please create new.",
			"INFO_1": "The Integrations module allows you to obtain real-time data by completing a form from different web services.",
			"INFO_2": "Some examples of how integrations are used:",
			"INFO_2_LI1": "Update selection fields with values loaded from an external server.",
			"INFO_2_LI2": "Send coordinates and autofill a physical address.",
			"INFO_2_LI3": "Validate whether a site is up to date with payments, a guarantee is valid, or if there is stock of a product.",
			"INFO_3": "Integrations support GET and POST requests",
			"INFO_TOGGLE_ARIA": "Show or hide information about integrations",
			"INFO_TOGGLE_TOOLTIP": "Click to show or hide the integrations description",
			"COLS": {
				"NAME": "Name",
				"DESCRIP": "Description",
				"TYPE": "Type",
				"SITE": "Site",
				"DEPT": "Department",
				"CONNECTION_TYPE": "Connection Type",
        "OFFLINE": "Offline",
        "CREATED_BY": "Created by",
        "CREATED_AT": "Created",
        "UPDATED_BY": "Modified by",
        "UPDATED_AT": "Modified"
			},
			"DIAG_DEL": {
				"TITLE": "Delete integration",
				"BODY": "Are you sure you want to delete the integration <strong>{{name}}</strong>?",
				"IN_USE": "The integration <strong>{{name}}</strong> is being used in the following forms:"
			},
			"DIAG_IMPORT": {
				"TITLE": "Import Integration",
				"INTEG_NAME": "Integration name",
				"SELECT": "Select file",
				"ACCEPT": "Import",
				"FILE_VALID": "Error reading JSON file. Please ensure the file is in a valid format.",
				"FILE_VALID_2": "Please select a valid file.",
				"NO_NAME_INTEG": "You must enter a name for the integration.",
				"CREATE_FAILED": "The integration could not be imported",
				"CREATE_NO_ID": "The integration was created but no valid identifier was returned"
			}
		},
		"DASH_SHEETS": {
			"TITLE": "Manage your Data Files",
			"IMPORT": "Import File",
			"NEW": "New File",
			"TITLE_1": "Files",
			"REFRESH_FILES": "Refresh Files",
			"NO_INFO": "There are no data files. Please create new ones.",
			"INFO_1": "Manage master lists of datasets to use in forms.",
			"COLS": {
				"NAME": "Name",
				"SITE": "Site",
				"DEPARTMENT": "Department"
			},
			"DIAG_DEL": {
				"TITLE": "Delete file",
				"BODY": "Do you want to delete the file {{name}}?"
			},
			"NEW_SHEET_PLACEHOLDER": "New file functionality in development",
			"OPEN_SHEET_PLACEHOLDER": "Open file functionality in development: {{name}}",
			"DELETED_SUCCESS": "File deleted successfully",
			"CREATED_SUCCESS": "File created successfully",
			"UPDATED_SUCCESS": "File updated successfully",
			"ERROR_CREATE": "Could not create the file",
			"ERROR_UPDATE": "Could not update the file",
			"ERROR_DELETE": "Could not delete the file",
			"MODAL": {
				"TITLE": "New File",
				"TITLE_EDIT": "Edit File",
				"NAME": "Name",
				"NAME_PLACEHOLDER": "Enter file name",
				"NAME_REQUIRED": "Name is required",
				"SITE": "Site",
				"SITE_REQUIRED": "Site is required",
				"DEPARTMENT": "Department",
				"SELECT_DEPARTMENT": "Select a department",
				"DEPARTMENT_REQUIRED": "Department is required",
				"GLOBAL": "Global",
				"VALIDATION_ERROR": "Please complete all required fields"
			}
		},
		"STATS": {
			"FILTER": "Filter by upload date",
			"CHK_AVERAGE": "Grouped by Month",
			"FILTER_BUTTON": "Filter",
			"REFRESH_BUTTON": "Refresh",
			"FROM_FILTER": "From",
			"UNTIL_FILTER": "Until",
			"NO_ITEMS": "You have no pending validations assigned to your user",
			"TITLE": "SURVEYED ITEMS",
			"TITLE_1": "Distribution of surveyed items by period",
			"INFO1": "The first 10 users of the detailed Records are graphed, you must modify the filters or the ordering to adjust to the desired information.",
			"TITLE_2": "Delay in sending data to the server (hs)",
			"INFO2_1": "The first 10 users of the Detailed Records are graphed, you must modify the filters or the ordering to adjust to the desired information.",
			"INFO2_2": "Time elapsed between the creation of the form and its submission to the server expressed in hours.",
			"TITLE_3": "Proportion of items released per member",
			"INFO3": "The first 10 users of the detailed Records are graphed, you must modify the filters or the ordering to adjust to the desired information.",
			"INFO5": "The first 10 departments and 10 forms of the Detailed Records are graphed, you must modify the filters or the ordering to adjust to the desired information.",
			"TITLE_4": "Detailed Logs",
			"TITLE_5": "Proportion of items collected by Department and form",
			"INFO4": "Items created grouped by member and their totals. The Delay(hs) column represents the time elapsed between the creation of the form and its submission to the server expressed in hours.",
			"DOWNLOAD": "Export grid to CSV",
			"DOWNLOAD_XLSX": "Export grid to XLSX",
			"NOTIFICATION": "Send Notification",
			"DELETE_USERS": "Delete Users",
			"COLS": {
				"DELAY": "Delay(hs)",
				"DELAY_TOOLTIP": "Time elapsed between the creation of the form and its submission to the server expressed in hours.",
				"DEPARTMENT": "Departament",
				"EMAIL": "Email",
				"FORM": "Form",
				"ITEMS": "Items",
				"LAST_ITEM": "Last Item",
				"MEMBER": "Member",
				"PERIOD": "Period",
				"TOTAL": "\"Total \""
			},
			"TITLEVALIDATIONS": "VALIDATIONS",
			"TITLEVALIDATIONS_1": "Record Validations by Forms",
			"TITLEVALIDATIONS_2": "Validations carried out by Supervisors by Date",
			"TITLEVALIDATIONS_3": "Average delay (hs) to validate"
		},
		"DASH_TASKS": {
			"ADVANCED": "Advanced",
			"SHOW_TEMPLATES": "View Templates",
			"NEW": "New task",
			"TASK_NO_AUTHORIZED": "The task belongs to another department",
			"DIAG_DEL": {
				"TITLE": "Delete task",
				"BODY": "Do you want to delete the task?",
				"BODY_REPEAT": "Repeats will be deleted too."
			},
			"DIAG_SAVE": {
				"TITLE": "Save task",
				"BODY": "Do you want to save task?"
			},
			"MODAL": {
				"INFO": "To create a new task for a user of the Field App, it is necessary to have previously defined the <strong>Site where said task must be performed</strong>, and verify that said user is part of a Team that is subscribed to the Form associated with the Task."
			},
			"FIELDS": {
				"ADMIN": "Admin",
				"K": "K",
				"CONSTANT": "Constant",
				"FIELD_ID": "Field",
				"NAME": "Name",
				"NAME_TOOLTIP": "Select a task template or enter a new name",
				"NAME_PLACEHOLDER": "Search task template...",
				"DESCRIP": "Description",
				"DESCRIP_PLACEHOLDER": "Task Description",
				"FORM": "Form",
				"FORM_PLACEHOLDER": "Search Form...",
				"SITE": "Site",
				"SELECT_SITE": "Select Site",
				"SELECT_SITE_COL": "Select column with Site name",
				"SITE_PLACEHOLDER": "Search Site...",
				"INFO_SITE_COL": "Existing Site Name in the Sites section",
				"ERROR_SITE_TITLE": "Error: Site",
				"ERROR_SITE_MESSAGE_START": "The site \"",
				"ERROR_SITE_MESSAGE_END": "\" is not loaded in the Sites section. Correct the file and repeat the loading process.",
				"ERROR_FORM_TITLE": "Error: Form",
				"ERROR_FORM_MESSAGE_START": "The form \"",
				"ERROR_FORM_MESSAGE_END": "\" is not loaded in the Forms section. Correct the file and repeat the loading process.",
				"ERROR_DEFAULT_TITLES": "Error: Columns",
				"ERROR_DEFAULT_TITLES_BODY": "Column titles must match the titles found in the sample file. Additional titles for metadata can be added below.",
				"USER": "User defined",
				"USERS": "Users",
				"DATE": "Date",
				"IMPORT_MODE": "Import mode",
				"AUTO_IMPORT": "Automatic file processing",
				"MANUAL_IMPORT": "Manual selection",
				"MANUAL_SELECTION": "Manual",
				"DYNAMIC_SELECTION": "Dynamic",
				"CALENDAR": "Calendar",
				"ALL_DAY": "All day",
				"NO_EXPIRATION": "No expiration",
				"START_DATE": "Start",
				"END_DATE": "End",
				"REPEAT": "Repeat",
				"REPEAT_EVERY": "Every few days",
				"REPEAT_TO": "Repeat until",
				"FIELD": "Field",
				"FIELD_PLACEHOLDER": "Field name",
				"VALUE": "Value",
				"VALUE_PLACEHOLDER": "Value to assign to the field",
				"METHOD": "Method",
				"URL": "URL",
				"AUTH": "Authorization",
				"QUERY_PARAMS": "Query Parameters",
				"HEADERS": "Headers",
				"PAYLOAD": "Payload",
				"FORMAT_JSON": "Format JSON"
			},
			"TEMPLATES": {
				"TITLE": "Tasks Templates",
				"NEW": "New template",
				"EDIT": "Edit template",
				"COPY": "Copy template",
				"INFO": "Templates allow you to add Values to a Task so that the Field App user has additional information associated with the Task. This could be Contact Name, Special Task Considerations, etc. Templates are saved and then used each time you want to generate a task with those associated values. This information appears in the Field Mobile App.",
				"NO_INFO": "It does not have any template for tasks. Please create a new one."
			}
		},
		"DASH_TASKS_ADVANCED": {
			"TITLE": "Advanced Tasks",
			"IMPORT_TITLE": "Import",
			"IMPORT_FILE": "Import File",
			"IMPORT_FILE_MANUAL": "Assisted Importation",
			"IMPORT_FILE_AUTO": "Automatic Importation",
			"EXPORT_FILE": "Export Records",
			"TASK_GRID": "Task Grid",
			"USERS_ASSIGN": "Users to Assign to Selected Tasks",
			"ASSIGN_SELECTED": "Assign Users to Selected Tasks",
			"DELETE": "Delete Selected Tasks",
			"BACK_TO_GRID": "Back to Task Grid",
			"COLS": {
				"START": "START",
				"END": "END",
				"TASK_NAME": "TASK NAME",
				"CLIENT": "SITE",
				"FORM": "FORM",
				"DESCRIPTION": "DESCRIPTION",
				"USERS": "USERS",
				"REPEAT": "REPEAT",
				"TYPE": "TYPE",
				"ALL": "ALL"
			},
			"REPETITIVE_TASKS": "Include Repetitive tasks already started",
			"FILTER_BUTTON": "Filter",
			"ASSIGN_USERS_TASKS": "Assign Users to the selected tasks",
			"REPLACE_PREVIOUS": "Replace previous",
			"TASK_ITEMS": "Task items",
			"SELECT_ITEM": "Select the loaded item",
			"IMPORT": {
				"SELECT_FILE": "File to import",
				"STEP_1": "1. Column separator character",
				"STEP_2": "2. File to upload",
				"STEP_2_SELECT_FILE": "Open File",
				"DOWNLOAD_FILE": "Download example file",
				"FILE_CONTENT": "File content",
				"INFO_MODAL_TITLE": "Basic Guide to Creating Files",
				"INFO_MODAL_PART_01": "The file to be imported must have a ",
				"INFO_MODAL_PART_02": ".csv",
				"INFO_MODAL_PART_03": "file extension and contain data organized in table format, where columns are separated by ",
				"INFO_MODAL_PART_04": "tabs",
				"INFO_MODAL_PART_05": " (TAB) or ",
				"INFO_MODAL_PART_06": "semicolons",
				"INFO_MODAL_PART_07": " (;). Each row in the file represents a unique data record, with the columns organized in a coherent and consistent manner.",
				"INFO_MODAL_PART_08": "For example, if we are importing task data, the file structure could be as follows:",
				"INFO_MODAL_PART_09": "In this example, each row represents a different task, and each column contains specific information about the task, such as the task ID, status, region, among others.",
				"INFO_MODAL_PART_10": "It is essential to maintain this file structure and ensure it has the .csv extension to guarantee correct data importation into the system. Each column should be clearly delimited by tabs or semicolons, and any extra spaces before or after the values should be avoided. This will facilitate the importation process and ensure that the data integrates correctly into the system.",
				"INFO_DATE": "Format: YYYY-MM-DD or DD/MM/YYYY",
				"INFO_HOUR": "Format: HH:mm or HH:mm:ss",
				"INFO_USERS": "Existing user email",
				"INFO_IMPORT_END": "The tasks were loaded and notified.",
				"ERROR_FORM": "Error: Form",
				"ERROR_FORM_TEXT": "The fields Date, Start, and End are required.",
				"ERROR_FORM_TEMPLATE": "Template selection is required.",
				"ERROR_FORM_TASK_NAME": "Task Name is required.",
				"ERROR_FORM_TASK_DESC": "Task Description is required.",
				"ERROR_FORM_CALENDAR_DATE": "Date is required.",
				"ERROR_FORM_CALENDAR_START": "Start time is required.",
				"ERROR_FORM_CALENDAR_END": "End time is required.",
				"ERROR_USERS_NOT_FOUND_TITLE": "Error: Users Not Found",
				"ERROR_USERS_NOT_FOUND_BODY": "The following emails were not found in the database, so the corresponding tasks were left without an assignee: ",
				"ERROR_DATE_TITLE": "Error: Date",
				"ERROR_DATE_MESSAGE_START": "The date or time in row ",
				"ERROR_DATE_MESSAGE_MID": " is not valid: ",
				"ERROR_DATE_MESSAGE_END": ". Use date YYYY-MM-DD or DD/MM/YYYY and time HH:mm or HH:mm:ss.",
				"ERROR_DATE_API": "Start and end dates could not be parsed. Use YYYY-MM-DD or DD/MM/YYYY and time HH:mm or HH:mm:ss.",
				"ERROR_SAVE_TITLE": "Error importing tasks",
				"ERROR_SAVE_BODY": "The tasks could not be created. Check the data and try again.",
				"DATA_IMPORT": "Data to import",
				"PROCESS": "Process",
				"PREVIEW": "Preview",
				"CHOOSE_TEMPLATE": "Select Template",
				"INFO_ADMIN": "By checking the box, this information will be exclusively available to the task scheduler and will not be displayed on the mobile application interface.",
				"TASK_NAME": "Task Name",
				"FORM": "Form",
				"DESCRIPTION_TASK": "Task Description",
				"METADATA": "Metadata",
				"IMPORTED_COLUMN": "Imported Column",
				"FIRST_LAST_REFERENCE": "First and Last value as reference",
				"CHOOSE_ONE": "Choose one already loaded",
				"CREATE_SITES": "<p>Sites will be created based on the import. You must fill in the name. These must have some dynamic column parameter.<br />For example in name, <i>WOM {col3}, {col4}</i></p><p>If it finds a site with the same name, it will use the one already loaded.</p>",
				"CREATE_IMPORTED_DATA": "Create one based on imported data",
				"GENERATE_TASKS": "Generate Tasks",
				"DELETE_FIRST_LINE": "Remove the first line"
			},
			"DIALOG_CONFIRM": {
				"BODY": "All information from the uploaded file will be deleted. Do you wish to continue?"
			}
		},
		"DASH_TEAM": {
			"TITLE": "Manage your team",
			"ADD": "Add users",
			"FIND": "Find the users you want to add to the team",
			"NO_INFO": "It does not have any members.",
			"FIELDS": {
				"NAME": "Name",
				"EMAIL": "Email",
				"DEVICE": "Associated device"
			},
			"RELEASE_DEVICE": "Unbind mobile device",
			"ACCOUNT": "Associated account",
			"DEL_TITLE": "Delete User",
			"DEL_BODY": "Do you want to remove user {{email}} from the group?",
			"DESV_TITLE": "Unlink user from device",
			"DESV_BODY": "Do you want to unlink user {{userName}} from the current device?",
			"DESV_ACCEPT": "Unbind",
			"LEADER": "Team Leader"
		},
		"DASH_TEAMS": {
			"TITLE": "Teams",
			"TITLE_TOOLTIP": "Add users to a team and then subscribe the team to a form.",
			"NEW": "New Team",
			"IN_NAME": "Enter the name of the new team",
			"SECTION_INFO": "<p>The Teams module is used to define the users who will be able to access and use the forms from the Field App.</p><p>Every user of the Mobile App must belong to a team. Teams are managed by the Owner of a department or by the Administrator.A team can have as many users as desired.</p><p>For example, the Owner of the Marketing Department can define a team for the promoters of the North Zone (team name) and another team for South Zone (other team name).That way, when you create a form, you define which team is authorized to see and use that form from their mobile device.</p> ",
			"NO_INFO": "The department does not have any team. Please create one.",
			"COLS": {
				"NAME": "Name",
				"MEMBERS": "Members"
			},
			"DIAG_DEL": {
				"TITLE": "Delete Team",
				"BODY": "By deleting the team, its users will no longer have access to the forms to which they are subscribed.",
				"ACCEPT": "Delete Team"
			},
			"MODAL": {
				"TITLE_EDIT": "Edit team name"
			}
		},
		"DASH_USERS": {
			"TITLE": "Manage your users",
			"TITLE_2": "Users",
			"TITLE_3": "Permissions and Assignments",
			"TITLE_4": "Statistics",
			"COMPANIES": "Companies",
			"PASSWORD_REQUIRED": "Password is required",
			"NO_INFO": "The does not have any users. Please invite new ones.",
			"SECTION_INFO": "<p>The Users Module allows you to manage (register, cancel and modify) system users. </p><p>There are three types of users.</p><p><strong>Administrator:</strong> Can register or invite users. Once the user receives the invitation by mail and registers, the Administrator can give him the privileges of Administrator, Owner (of Department) or Supervisor (of Department). An Administrator can also create, edit and delete forms, create Teams and create Departments. Both an Administrator and an Owner can unpair devices. This is disassociating a device from its user so that it can be used by another user.</p> <p><strong>Owner:</strong> You can register users and create Teams only for your Department. You can also create, edit and delete forms. Can view and download data to your PC.</p> <p><strong>Supervisor:</strong> Can only view forms and view and download data.</p> <p><strong>Mobile:</strong > You can only use the Field App, once you have been incorporated into a Team and your Team has been subscribed to a Form. Cannot access the Field website.</p> ",
			"COMPANY": {
				"COMPANY": "Company",
				"ADD_COMPANY": "New Company",
				"EDIT_COMPANY": "Edit Company",
				"NAME": "Name",
				"CODE": "Code",
				"NO_COMPANIES": "No companies found",
				"ERROR_COMPANY_NEW": "The company could not be created",
				"ERROR_COMPANY_MODIFY": "The company could not be modified",
				"ERROR_COMPANY_DELETE": "The company could not be deleted",
				"DIAG_DEL": {
					"TITLE": "Delete company",
					"BODY": "Only companies without associated users can be deleted."
				}
			},
			"COLS": {
				"ACTIVE": "Active",
				"CLIENTS": "SITES",
				"CECO": "Cost Centre",
				"REGION": "Region",
				"NAME": "Name",
				"FIRSTNAME": "FirstName",
				"LASTNAME": "LastName",
				"COMPANY": "Company",
				"OFFICE": "Office",
				"DEPARTMENT": "Department",
				"TITLE": "Title",
				"EMPLOYEENUMBER": "Employee number",
				"EMAIL": "Email",
				"DISP_ASOC": "Associated device",
				"LAST_LOGON": "Last Logon",
				"CREATED_AT": "Created At",
				"PRIVILEGES": "Privileges",
				"PASSWORD": "New password",
				"COMBO": {
					"SELECTION": "Selection",
					"MAKE_ADMIN": "Make Admin",
					"UNMAKE_ADMIN": "Remove Admin"
				},
				"RELEASE_DEVICE": "Unbind mobile device",
				"ASSOC_ACCOUNT": "Associated Account"
			},
			"STATISTICS": {
				"TITLE": "User Statistics",
				"TITLE_TENANT": "Tenant Statistics: ",
				"ACTIVE": "Active Users",
				"CREATED": "Created Users",
				"DELETED": "Deleted Users",
				"INACTIVE": "Inactive Users",
				"CREATED_DELETED_INACTIVE": "Created/Deleted/Inactive Users",
				"TOTAL": "Total Items",
				"ITEMS": "Items",
				"FORM": "Form",
				"USER": "User",
				"DATA_LIST": "Data List",
				"DATES_ERROR": "Error in the entered dates. They cannot exceed the current date and must have a maximum interval of 3 months."
			},
			"ACCESS_LOG": {
				"TRANSACTIONS": "Transacciones de Usuarios",
				"USER_STATISTICS_ERROR": "Error retrieving user statistics information:",
				"USERS_WITH_MOVEMENTS": "Number of Users with Movements",
				"USERS_WITH_VALIDATIONS": "Number of Users with Validations",
				"USERS_WITH_CREATIONS": "Number of Users with Created Items",
				"ACCESS_ERROR": "Error retrieving access log information"
			},
			"NOTIFICATION": {
				"TITLE": "Send Push Notification to mobiles",
				"MSG_TITLE": "Title of the message",
				"MSG_BODY": "Message body",
				"SEND": "Send message"
			},
			"INVITE": {
				"BT": "Invite user",
				"TITLE": "Invite users to the account",
				"IN_EMAIL": "Enter the email of the users you want to invite",
				"IN_EMAIL_TOOLTIP": "Enter an email and press enter. You can enter several separating them by commas.",
				"IN_EMAIL_PLACEHOLDER": "I searched for users",
				"ADD_USER": "Add users"
			},
			"NEW": {
				"BT": "User registration",
				"TITLE": "Registration of users to the account",
				"ADD_USER": "Add user"
			},
			"EDIT": {
				"TITLE": "Edit user"
			},
			"SITES": {
				"TITLE": "Sites",
				"HELP": "Select the sites the user belongs to"
			},
			"API_TOKEN": {
				"TITLE": "API Token",
				"GENERATE": "Generate token",
				"SHOW": "Show token",
				"HIDE": "Hide token",
				"COPY": "Copy token",
				"COPIED": "Token copied",
				"COPY_ERROR": "The token could not be copied",
				"DELETE": "Delete token",
				"GENERATE_ERROR": "The token could not be generated",
				"DELETE_ERROR": "The token could not be deleted",
				"DIAG_DEL": {
					"TITLE": "Delete API Token",
					"BODY": "Do you want to delete the API Token? You will need to generate a new one to use it again.",
					"ACCEPT": "Delete"
				}
			},
			"DIAG_MAKEADMIN": {
				"TITLE": "Make admin",
				"BODY": "Do you want to modify the privileges ?",
				"ACCEPT": "Make Administrator"
			},
			"DIAG_UNMAKEADMIN": {
				"TITLE": "Remove admin",
				"BODY": "Do you want to modify the privileges?",
				"ACCEPT": "Remove Administrator role"
			},
			"DIAG_REL_DEV": {
				"TITLE": "Unbind user from device",
				"BODY": "Do you want to unlink user {{userName}} from the current device?",
				"ACCEPT": "Unbind"
			},
			"DIAG_REMOVE_USER": {
				"TITLE": "Delete user",
				"BODY": "Do you want to delete the users ?{{usersEmail}}",
				"ACCEPT": "Delete"
			}
		},
		"DASH_WEBHOOKS": {
			"TITLE": "Manage your webhooks",
			"TITLE_2": "Webhooks",
			"NO_INFO": "The does not have any webhooks. Please create one.",
			"SECTION_INFO": "<p>The Webhooks module significantly extends the scope of Field by allowing notifications to be sent in real time, every time an item is uploaded.</p><p>Some examples of what webhooks allow :</p> <ul> <li>Save the items (data collected in the field from the Field app) in the client's database as they are uploaded from the mobile device.</li><li> Activate internal alarms when receiving an item with certain characteristics.</li><li>Update data in the company's management system in real time.</li><li>You can generate reports or send emails with important data as the items are uploaded.</li> </ul> <p>To configure the webhook you need a server with an endpoint that supports GET and POST requests.At the time the webhook is created, a GET request will be sent.</p > <p>The url of the request will include queries with the values ​​challenge and verify_token.</p> <p>In order to create the webhook correctly, the server should respond with a status 200 and the challenge sent in the body. The verify_token is for the client's personal use, and allows to ensure that the request was configured by the Field administrator in the company.</p> <p>Once the Webhook has been successfully created, go to the Forms section and subscribe them to webhooks. Every time an item is uploaded, it will be sent in the body of a POST to your server.</p>",
			"COLS": {
				"TYPE": "Type",
				"CALLBACK": "Callback URL",
				"COMBO": {
					"TYPE_FORM": "Forms",
					"TYPE_NA": "No Type"
				}
			},
			"NEW": {
				"BT": "New webhook"
			},
			"TITLE_NEW": "Add new webhook",
			"TITLE_EDIT": "Edit webhook",
			"TOKEN": "Verification token",
			"DIAG_REMOVE": {
				"TITLE": "Delete WebHook",
				"BODY": "Do you want to remove the webhook?"
			}
		},
		"DASH_WIZARD": {
			"HELP_CENTER": {
				"TITLE": "Help Center",
				"TITLE_2": "How to get started?"
			},
			"TITLE": "Wizard",
			"TITLE_2": "Using the Wizard",
			"TUTORIALS": "Tutorials",
			"VIEW_PLAYLIST": "View full playlist",
			"SECTION_INFO": "To start collecting data from a mobile device using the Field app, it is necessary to previously define some components.<br />These are:<br /><br /><ol><li>Department within the organization for which the data is collected.</li><li>Users, who can later be defined as Owners or otherwise are responsible for collecting field data with mobile devices.</li><li> Owner or person in charge of the Department The owner of a Department is responsible for registering users and sites, generating forms, defining teams, and creating and assigning tasks to users (eg Maintenance).</li><li> Name of the Teams, made up of users, associated with the Departments and who have the privileges to access the forms (eg Maintenance Technicians).</li><li>Members of the Teams, users that make up the teams ( A user can belong to more than one team).</li><li>Create the Form.</li><li>Subscribe the Team to the Formula river.</li></ol>",
			"START": "Start",
			"START_DENIED": "You need administrator or owner permissions to start configuring.",
			"NOSELECT_ERR_TOAST": {
				"DEPT": "You have not selected a Department",
				"OWNER": "You have not assigned an Owner",
				"USERS_OK": "No Confirmed Users found",
				"TEAM": "No Team selected",
				"TEAM_USERS": "No Users were assigned to the Team"
			},
			"DEPARTMENT": {
				"TITLE": "Department Creation",
				"SELECT_DEPT_TOAST": "Selected Department",
				"INFO": "Create a new Department or select an existing one to assign Owner, Teams and Forms.",
				"TITLE_2": "List of departments already created:",
				"NEW": "Create New Department"
			},
			"USERS": {
				"TITLE": "User Invitation",
				"INVITE_DUPLICATE_ERR_TOAST": "The email used already belongs to a Field account.",
				"INVITE_ERR_TOAST": "Error checking email.",
				"INVITE_OK_TOAST": "The indicated user(s) have been invited",
				"INFO": "To invite a user, you must enter their email account. The user will receive an email, which must be confirmed by registering their name and password. Until the guest confirms the email and registers their name and password, your name will be listed as \"To Be Confirmed\".",
				"TITLE_2": "List of Confirmed Users:"
			},
			"OWNER": {
				"TITLE": "Department Owner Assignment",
				"INFO": "The owner of a Department is responsible for registering users and sites, and also for generating forms, defining teams, and creating and assigning tasks to users.",
				"TITLE_2": "List of Apartment Owners:",
				"INFO_2": "By having at least one Owner assigned, it is possible to continue with the next step.",
				"INFO_3": "Since you do not have at least one Owner assigned, you must assign one to continue with the next step."
			},
			"TEAM": {
				"TITLE": "Team Creation",
				"SELECT_OK": "Selected team",
				"INFO": "The teams module is used to enable or give permission to a group of users to use a given form. Every user must belong to a team. Teams are managed by the Owner of a department and are associated with that Department.",
				"INFO_2": "The selected Department has no assigned Teams. Please assign one to continue.",
				"TITLE_2": " Department Equipment List:"
			},
			"TEAMUSERS": {
				"TITLE": "User Assignment",
				"INFO": "Every Team must have at least one user assigned.",
				"INFO_2": "The selected team has no assigned users. Please assign one to continue.",
				"TITLE_2": "List of Users assigned to the Team:"
			},
			"FORMS": {
				"TITLE": "Form Creation",
				"SELECT_OK": "Selected Form",
				"DIAG_NEW": {
					"TITLE": "Create form",
					"BODY": "Do you want to create a form?",
					"ACCEPT": "Create"
				},
				"INFO": "Finally you can configure a new Form or select one among those created for the selected Department.",
				"INFO_2": "The selected department has no Forms.",
				"TITLE_2": "Department Forms List:"
			}
		},
		"DASH_VALIDATIONS": {
			"TITLE": "Pending validations",
			"INFO": "Field Validation Module.",
			"VALIDATE": "Validate",
			"VALIDATE_MULTI": "Multiple Validation",
			"VALIDATED": "Validated",
			"NO_GRAPHS_TITLE": "No graphs available",
			"NO_GRAPHS_MESSAGE": "Your departments do not have any graphs. Please create graphs in the departments to view them here.",
			"NO_DEPT_GRAPHS": "The selected department does not have any graphs",
			"NO_FORMS_TITLE": "No forms available",
			"NO_FORMS_MESSAGE": "Your departments do not have any forms. Please create forms in the departments to view them here.",
			"NO_DEPT_FORMS": "The selected department does not have any forms",
			"STATES": {
				"PENDING": "Pending",
				"OK": "Approved",
				"REJECT": "Rejected"
			},
			"STAGE_CHANGED": "This record was already validated or changed stage. Refresh the view and try again.",
			"COLS": {
				"DATE": "Date",
				"VALIDATION_DATE": "Validation",
				"TYPE": "Type",
				"USER": "User",
				"SUPPLIER": "Supplier",
				"ID": "ID",
				"SECTION": "Section",
				"DEPARTMENT": "Departament",
				"RECORDS": "Records of",
				"TITLE": "Record Title",
        "AGREEMENT": "Agreement",
        "ASSET": "Asset",
        "COMPANY": "Company",
        "STATE": "State"
			},
			"FILTER_STATE": "Filter by state"
		},
		"DIRECTIVES": {
			"SIGN_VALIDATE": {
				"SIGN": "Sign",
				"NO_SIGN": "Not Signed",
				"CLEAR": "Clear"
			},
			"FILE_VALIDATE": {
				"UPLOAD": "Upload File",
				"NO_FILE": "No Files",
				"UPLOADING": "Uploading",
				"DOWNLOAD": "Download",
				"DELETE": "Delete",
				"ATTACHMENTS": "Attachments"
			}
		}
	}
}